import { Permisos } from './../../providers/authentication/permisos.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild } from '@angular/core';
import { BreadcrumbService } from '../../breadcrumb.service';
import { Compass } from '../../domain/compass';
import { SeccionPlano, ContenidoPlano, PlanoComponent } from 'interiores-mapa';
import { ConexionPlano } from 'interiores-mapa';
import { NodoPlano } from 'interiores-mapa';
import { AuthenticationService } from '../../providers/authentication/authentication.service';
import { EntityManagerProvider } from '../../providers/entity-manager-provider/entity-manager-provider';
import { ServiciosWebServiceProvider } from '../../providers/web-service-service/servicios-web-service';
import { TranslateService } from 'ng2-translate';
import { Message } from 'primeng/primeng';
import { MenuItem } from 'primeng/api';
import {  ActivatedRoute, Params } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { ConexionFormulario } from '../../domain/ConexionFormulario';
import { NodoFormulario } from '../../domain/NodoFormulario';
import { SeccionFormulario } from '../../domain/SeccionFormulario';
import { Contenido } from '../../domain/Contenido';
import * as d3RadialMenu from 'd3-radial-menu';
import * as allSettled from 'promise-all-settled';
import {
	Predicate
} from 'breeze-client';
import { Idioma } from '../../domain/Idioma';
import { IdiomaService } from '../../providers/idioma/idioma.service';
import { AlaFormulario } from '../../domain/AlaFormulario';
import { Constantes } from '../../domain/constantes';
import { zoom_coordenadasPlano } from 'interiores-mapa/dist/zoom_coordenadasPlano';
import { zoomCenterCoordsPlano } from 'interiores-mapa/dist/zoomCenterCoordsPlano';
import { PermisosService } from '../../providers/authentication/permisos.service';
import * as Q from 'q';
import { AppComponent } from '../../app.component';
import { BalizaFormulario } from '../../domain/BalizaFormulario';
import { BeaconPlano } from 'interiores-mapa/dist/beaconPlano';
import { IdiomaCalendario } from '../../domain/IdiomaCalendatio';
import { NotificacionPlano } from 'interiores-mapa/dist/notificacionPlano';
import { AvisoCiudadanoFormulario } from '../../domain/AvisoCiudadanoFormulario';
import { Router } from '@angular/router';
import { Planta, VerticalManager } from '../../domain/Vertical';

const D3SCALEMENU = 1;
const D3ICONSIZEMENU = 64;
const D3RADIUSMENU = 40;
const D3THICKNESSMENU = 70;
@Component({
	templateUrl: './mapas.component.html',
	styleUrls: ['./mapas.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MapasComponent implements OnInit, OnDestroy {
	spinner: HTMLElement;
	blockUI: HTMLElement;
	movible: boolean;
	pathPlano: String;
	currentZoomLevel: number = 1;
	zoomLevels: Number[];
	zoomCenterCoords: Number[];
	zoomCenterTransitionDuration: number;
	zoom_coordenadas: zoom_coordenadasPlano;
	verticalManager: VerticalManager;
	sections: Array<SeccionPlano>; // Alimenta al componente Plano, son las secciones que se mostraran
	mapSections: Map<String, SeccionPlano>; // Coleccion con todos los Secciones
	seccionEdicion: SeccionFormulario = new SeccionFormulario();

	nodes: Array<NodoPlano>; // Alimenta al componente Plano, son los nodos que se mostraran
	mapNodes: Map<String, NodoPlano>; // Coleccion con todos los Nodos
	nodoEdicion: NodoFormulario = new NodoFormulario();

	links: Array<ConexionPlano>; // Alimenta al componente Plano, son las conexiones que se mostraran
	mapLinks: Map<String, ConexionPlano>; // Coleccion con todos los Conexiones
	conexionEdicion: ConexionFormulario = new ConexionFormulario();

	beacons: Array<BeaconPlano>; // Alimenta al componente Plano, son las balizas que se mostraran
	mapBeacons:  Map<String, BeaconPlano>; // Coleccion con todos los Balizas
	balizaEdicion: BalizaFormulario = new BalizaFormulario();

	contents: Array<ContenidoPlano> = []; // Alimenta al componente Plano, son los contenidos que se mostraran
	mapContents: Map<String, ContenidoPlano>; // Coleccion con todos los Contenidos
	contenidosFormulario: Contenido[] = [];
	contenidoEdicion: Contenido = new Contenido();

	notifications: Array<NotificacionPlano> = []; // Alimenta al componente Plano, son las Notificaciones que se mostraran
	mapNotifications: Map<String, NotificacionPlano>; // Coleccion con todos las Notificaciones
	notificacionEdicion: AvisoCiudadanoFormulario = new AvisoCiudadanoFormulario();


	seccionDefecto: any;
	tipologiaDefecto: any;
	perfilesMovilidadDefecto: any;

	colorSeleccionado: any = '#00000';
	cursorPointer: string = '';
	conexionEdicionVuelta: ConexionFormulario = new ConexionFormulario();
	tramoNodoOrigen: NodoPlano;
	tramoNodoDestino: NodoPlano;
	idAla: string;
	alaSeleccionada: any;
	mapaZoom = 1;
	tipologias: any[] = [];
	perfilesMovilidad: any[] = [];
	idHardwareBalizas: any[] = [];
	// listaNiveles: any[] = [];
	msgs: Message[] = [];
	estadoEdicion: string = '';
	subEstadoEdicion: string = '';
	backLabel: string = '';
	pathSvgPlano: string;
	hammer: any;
	@ViewChild('plano') plano: PlanoComponent;
	compass: Compass;
	mpClick: any = null;
	displayDialogNuevaSeccion = false;
	displayDialogEditarSeccion = false;
	apareceBoton = false;
	displayDialogNuevoNodo = false;
	displayDialogEditarNodo = false;
	displayDialogNuevaConexion = false;
	displayDialogEditarConexion = false;
	displayDialogContenido = false;
	displayDialogCrearSeccion = false;
	displayDialogBaliza = false;

	formularioNodoMaximizado = true;
	formularioSeccionMaximizado = true;
	formularioConexionMaximizado = true;
	displayDialogAla = false;
	mapasMenuItems: MenuItem[] = [];
	// edicionMenuItems: MenuItem[] = [];
	mapasMenuVisibilidad: MenuItem[] = [];
	mostrarNodos: boolean;
	mostrarSecciones: boolean;
	mostrarTramos: boolean;
	mostrarContenidos: boolean;
	mostrarBalizas: boolean;
	mostrarNotificaciones: boolean;

	sectionsOpacity: number = 1;
	nodesOpacity: number = 1;
	linksOpacity: number = 1;
	contentsOpacity: number = 1;
	beaconsOpacity: number = 1;
	notificationsOpacity: number = 1;

	opacidad: number = 1;

	// nivelSeleccionado: any;
	alasPortal: AlaFormulario[] = [];
	uploadedFilesAla = [];
	imagenAlaSeleccionada: any;
	selectorImagenAla: any;
	formAla: FormGroup;
	//  radialMenu: D3RadialMenu;
	/* ** IDIOMAS ** */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;

	/* ** PERMISOS ** */
	permisos: Permisos = new Permisos();

	// Almacena los estados de las capas para poder ocultarlas y restaurarlas en las ediciones
	private elementosOcultadosNoEdicionOrigen = {};
	zoomAndCenterCoords = new zoomCenterCoordsPlano(0, 0, 0, 0, 1, [0, 0]);
	protected section_segment_menu: any = null;
	protected section_conector_menu: any = null;
	protected link_segment_menu: any = null;
	protected link_conector_menu: any = null;
	protected node_menu: any = null;

	// Para asociar Balizas a nodos
	balizaAsociarSeleccionada: BalizaFormulario = new BalizaFormulario();
	balizasResaltar: BeaconPlano[] = []; // Usado para resaltar un conjunto de balizas y controlar cuales estan resaltadas y cuales no.
	fechaVisualizacion: Date = new Date();
	tipologiasBaliza: any[];
	alaSeleccionada2: any;
	nivelSeleccionado: any;

	//tipologias seccion
	opcionesSelectorTipologia: any[]  = [];

	constructor(
		private appComponent: AppComponent,
		private breadcrumbService: BreadcrumbService,
		//  private eventService: EventService,
		private entityManagerProvider: EntityManagerProvider,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private route: ActivatedRoute,
		public idiomaService: IdiomaService,
		private translate: TranslateService,
		private router: Router,
		private permisosService: PermisosService,
		private entityManager: EntityManagerProvider,
	) {
		this.movible = false;
		this.backLabel = this.translate.instant('Mapas.atras');
		this.breadcrumbService.setItems([
			{ label: this.translate.instant('Mapas.mapas'), routerLink: ['/mapas'] },
			{ label: this.translate.instant('Mapas.plano') }
		]);
		this.route.params.subscribe(params => {
		});
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';
		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
	}
	ngOnInit() {
		const that = this;
		window.scroll(0, 0);
		this.spinner.style.display = 'inherit';

		this.fechaVisualizacion = new Date();

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

		this.route.params.subscribe((params: Params) => {
			this.idAla = params['id'];
			console.log('this.alaId = ' + this.idAla);
			this.entityManagerProvider.getIDIOMA()
			.then(function (idiomasENTIDAD: any) {
				that.idiomas = [];
				idiomasENTIDAD.forEach(idioma => {
					if(idioma.Visible === true){
					that.idiomas.push(new Idioma(idioma));
					}
				});
				that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
				that.idiomaSeleccionado = that.idiomaDefecto;

				return that.comprobarPermisos(that);
			})
			.then(function(){
				return that.obtenerALA(that.idAla, that);
			})
			.then(function(){
				return that.obtenerBalizasTotales();
			})
			.then(function(){
				return that.obtenerTIPOLOGIAS(that);
			})
			.then(function(){
				return that.obtenerPERFIL_MOVILIDAD_CIUDADANO(that);

			})
			.then(function(){
				return that.entityManagerProvider.getTIPOLOGIA_BALIZA();
			})
			.then(function(tipos){
				that.tipologiasBaliza = tipos;
			})
			.then(function(){
				return that.permisosService.obtenerTIPOLOGIA_SECCION();
			})
			.then(function(tipologias){
				console.log(tipologias)
				that.opcionesSelectorTipologia = tipologias;
				that.opcionesSelectorTipologia = that.opcionesSelectorTipologia.filter(o => o.Activa === true);
				console.log(that.opcionesSelectorTipologia)
				that.opcionesSelectorTipologia.sort((one: any, two: any) => {
					var textA = one.Nombre.toUpperCase();
					var textB = two.Nombre.toUpperCase();
					return textA.localeCompare(textB);
				});

				that.inicializarMenu();

				// Ocultamos Spinner
				that.spinner.style.display = 'none';
			})
			.catch(function(){
				// Ocultamos Spinner
				that.spinner.style.display = 'none';
			});
		});
	}
	ngOnDestroy(): void {
		this.entityManagerProvider.RejectChanges();
	}
	mostrarNombre(){
		const that = this;
		return this.alaSeleccionada.NIVEL.Nombre + "-" +  this.alaSeleccionada.Nomobre;
	}
	comprobarPermisos(that?) {
		that = this !== undefined ? this : that;
		const userId = that.authService.getIdUsuario();
		return that.permisosService.getPermisosUsuario(userId)
		.then(function(permisos){
			that.permisos = permisos;
		})
		.catch(function(err){
			throw err;
		});
	}

	obtenerBalizasTotales() {
		const that = this;

		const idEspacio = that.authService.getIdEspacio();

		return this.entityManager.getBALIZA()
		.then(function(BALIZAs){

			BALIZAs.forEach(element => {
					const baliza = new BalizaFormulario().fromENTIDAD(element);
					that.idHardwareBalizas.push(baliza.IdHardware);
				});
				
		});
	}

	inicializarMenu() {
		this.mapasMenuVisibilidad = [];
		this.mapasMenuItems = [];

		// Menu Visibilidades
		if (this.permisos.Mapa_plano_nodo !== 0){
			this.mapasMenuVisibilidad.push( { label: this.translate.instant('Mapas.nodoscapa'), id: 'NODOS', icon: 'iticon-tab-mostrar iticon-px32', command: (event: any) => { this.menuVisibilidadCommand(event); } } );
		}
		if (this.permisos.Mapa_plano_seccion !== 0){
			this.mapasMenuVisibilidad.push( { label: this.translate.instant('Mapas.seccionescapa'), id: 'SECCIONES', icon: 'iticon-tab-mostrar iticon-px32', command: (event: any) => { this.menuVisibilidadCommand(event); } });
		}
		if (this.permisos.Mapa_plano_conexion  !== 0) {
			this.mapasMenuVisibilidad.push( 	{ label: this.translate.instant('Mapas.tramoscapa'), id: 'TRAMOS', icon: 'iticon-tab-mostrar iticon-px32', command: (event: any) => { this.menuVisibilidadCommand(event); } });
		}
		if (this.permisos.Mapa_plano_contenido  !== 0) {
			this.mapasMenuVisibilidad.push({ label: this.translate.instant('Mapas.contenidoscapa'), id: 'CONTENIDOS', icon: 'iticon-tab-mostrar iticon-px32', command: (event: any) => { this.menuVisibilidadCommand(event); } });
		}
		if (this.permisos.Mapa_plano_balizas  !== 0) {
			this.mapasMenuVisibilidad.push({ label: this.translate.instant('Mapas.balizascapa'), id: 'BALIZAS', icon: 'iticon-tab-mostrar iticon-px32', command: (event: any) => { this.menuVisibilidadCommand(event); } });
		}
		if (this.permisos.Mensajes_ver_mensaje  !== 0) {
			this.mapasMenuVisibilidad.push({ label: this.translate.instant('Mapas.notificacionescapa'), id: 'NOTIFICACIONES', icon: 'iticon-tab-mostrar iticon-px32', command: (event: any) => { this.menuVisibilidadCommand(event); } });
		}


		// Menu Crear/Editar
		this.mapasMenuItems.push({
			label: this.translate.instant('Mapas.elementos'),
			disabled: true,
			styleClass: 'mapasMenuItemsHeader'
		});
		this.mapasMenuItems.push({
			separator: true
		});

		if (this.permisos.Mapa_plano_nodo !== 0){

			if (this.permisos.Mapa_plano_nodo_formulario === 2) {
				this.mapasMenuItems.push({
					label: this.translate.instant('Mapas.nodos'),
					icon: 'iticon-nodo iticon-px32',
					styleClass: 'mapasMenuItemsHeader',
					items: [
						{
							label: this.translate.instant('Mapas.nodos'),
							disabled: true,
							styleClass: 'mapasMenuItemsHeader'
						},
						{
							separator: true
						},
						{ label: this.translate.instant('Mapas.editar'), id: 'NODO_SELEC', icon: 'iticon-nodo-sel iticon-px32', command: (event: any) => { this.menucommand(event); } },
						{ label: this.translate.instant('Mapas.crear'), id: 'NODO_CREAR', icon: 'iticon-nodo-crear iticon-px32', command: (event: any) => { this.menucommand(event); } }
					]
				});
			}
			else if (this.permisos.Mapa_plano_nodo_formulario === 1) {
				this.mapasMenuItems.push({
					label: this.translate.instant('Mapas.nodos'),
					icon: 'iticon-nodo iticon-px32',
					styleClass: 'mapasMenuItemsHeader',
					items: [
						{
							label: this.translate.instant('Mapas.nodos'),
							disabled: true,
							styleClass: 'mapasMenuItemsHeader'
						},
						{
							separator: true
						},
						{ label: this.translate.instant('Mapas.editar'), id: 'NODO_SELEC', icon: 'iticon-nodo-sel iticon-px32', command: (event: any) => { this.menucommand(event); } }
					]
				});
			}
			else{
				// Nada
			}



		}
		if (this.permisos.Mapa_plano_seccion !== 0){

			if (this.permisos.Mapa_plano_seccion_formulario === 2) {
				this.mapasMenuItems.push({
					label: this.translate.instant('Mapas.secciones'),
					icon: 'iticon-seccion iticon-px32',
					styleClass: 'mapasMenuItemsHeader',
					items: [
						{
							label: this.translate.instant('Mapas.secciones'),
							disabled: true,
							styleClass: 'mapasMenuItemsHeader'
						},
						{
							separator: true
						},
						{ label: this.translate.instant('Mapas.editar'), id: 'SECCION_SELEC', icon: 'iticon-seccion-sel iticon-px32', command: (event: any) => { this.menucommand(event); } },
						{ label: this.translate.instant('Mapas.crear'), id: 'SECCION_CREAR', icon: 'iticon-seccion-crear iticon-px32', command: (event: any) => { this.menucommand(event); } }
					]
				});
			}
			else if (this.permisos.Mapa_plano_seccion_formulario === 1) {
				this.mapasMenuItems.push({
					label: this.translate.instant('Mapas.secciones'),
					icon: 'iticon-seccion iticon-px32',
					styleClass: 'mapasMenuItemsHeader',
					items: [
						{
							label: this.translate.instant('Mapas.secciones'),
							disabled: true,
							styleClass: 'mapasMenuItemsHeader'
						},
						{
							separator: true
						},
						{ label: this.translate.instant('Mapas.editar'), id: 'SECCION_SELEC', icon: 'iticon-seccion-sel iticon-px32', command: (event: any) => { this.menucommand(event); } }
					]
				});
			}
			else{
				// Nada
			}


		}
		if (this.permisos.Mapa_plano_conexion !== 0){


			if (this.permisos.Mapa_plano_conexion_formulario === 2) {
				this.mapasMenuItems.push({
					label: this.translate.instant('Mapas.tramos'),
					icon: 'iticon-tramo iticon-px32',
					styleClass: 'mapasMenuItemsHeader',
					items: [
						{
							label: this.translate.instant('Mapas.tramos'),
							disabled: true,
							styleClass: 'mapasMenuItemsHeader'
						},
						{
							separator: true
						},
						{ label: this.translate.instant('Mapas.editar'), id: 'TRAMO_SELEC', icon: 'iticon-tramo-sel iticon-px32', command: (event: any) => { this.menucommand(event); } },
						{ label: this.translate.instant('Mapas.crear'), id: 'TRAMO_CREAR', icon: 'iticon-tramo-crear iticon-px32', command: (event: any) => { this.menucommand(event); } }
					]
				});
			}
			else if (this.permisos.Mapa_plano_conexion_formulario === 1) {
				this.mapasMenuItems.push({
					label: this.translate.instant('Mapas.tramos'),
					icon: 'iticon-tramo iticon-px32',
					styleClass: 'mapasMenuItemsHeader',
					items: [
						{
							label: this.translate.instant('Mapas.tramos'),
							disabled: true,
							styleClass: 'mapasMenuItemsHeader'
						},
						{
							separator: true
						},
						{ label: this.translate.instant('Mapas.editar'), id: 'TRAMO_SELEC', icon: 'iticon-tramo-sel iticon-px32', command: (event: any) => { this.menucommand(event); } }
					]
				});
			}
			else{
				// Nada
			}

		}
		if (this.permisos.Mapa_plano_balizas !== 0){
			if (this.permisos.Mapa_plano_baliza_formulario === 2) {

				this.mapasMenuItems.push({
					label: this.translate.instant('Mapas.beacons'),
					icon: 'iticon-nodo-baliza iticon-px32',
					styleClass: 'mapasMenuItemsHeader',
					items: [
						{
							label: this.translate.instant('Mapas.beacons'),
							disabled: true,
							styleClass: 'mapasMenuItemsHeader'
						},
						{
							separator: true
						},
						{ label: this.translate.instant('Mapas.editar'), id: 'BALIZA_SELEC', icon: 'iticon-ficha-baliza-sel iticon-px32', command: (event: any) => { this.menucommand(event); } },
						{ label: this.translate.instant('Mapas.crear'), id: 'BALIZA_CREAR', icon: 'iticon-ficha-baliza-crear iticon-px32', command: (event: any) => { this.menucommand(event); } }
					]
				});
			}
			else if (this.permisos.Mapa_plano_baliza_formulario === 1) {

				this.mapasMenuItems.push({
					label: this.translate.instant('Mapas.beacons'),
					icon: 'iticon-nodo-baliza iticon-px32',
					styleClass: 'mapasMenuItemsHeader',
					items: [
						{
							label: this.translate.instant('Mapas.beacons'),
							disabled: true,
							styleClass: 'mapasMenuItemsHeader'
						},
						{
							separator: true
						},
						{ label: this.translate.instant('Mapas.editar'), id: 'BALIZA_SELEC', icon: 'iticon-ficha-baliza-sel iticon-px32', command: (event: any) => { this.menucommand(event); } }
					]
				});
			}
			else{
				// Nada
			}

		}

	}

	obtenerAVISO_CIUDADANO(that?) {
		that = this !== undefined ? this : that;
		const entityManager = that.entityManagerProvider;
		return entityManager.getAVISO_CIUDADANO(undefined, 'NODOS')
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY AVISO_CIUDADANO');
			}
			else {
				console.log('NOTIFICACIONES CARGADAS CORRECTAMENTE = ' + entidades.length);
				that.notificaciones = entidades;

				entidades.forEach(AVISO_CIUDADANO => {
					if (AVISO_CIUDADANO.NODOS.length > 0) {
						// NOTIFICACION
						const avisoPlano = new NotificacionPlano(AVISO_CIUDADANO.Id, AVISO_CIUDADANO.Titulo, AVISO_CIUDADANO.X, AVISO_CIUDADANO.Y, 'assets/itsoft/IconosSVG/email.svg', null, that.nodes[0].getIconScale());
						avisoPlano.setX(AVISO_CIUDADANO.X);
						avisoPlano.setY(AVISO_CIUDADANO.Y);

						avisoPlano.setSimbolo('assets/itsoft/IconosSVG/email.svg');
						avisoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
						avisoPlano.symbolFill = Constantes.contenidoSymbolFill;
						avisoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
						avisoPlano.symbolSize = Constantes.contenidoSymbolSize;

						avisoPlano.sectionHoverFill =   Constantes.nodoSectionHoverFill_SELECT;
						avisoPlano.sectionHoverStroke =   Constantes.nodoSectionHoverStroke_SELECT;
						avisoPlano.symbolHoverFill = Constantes.nodosymbolHoverFill;
						avisoPlano.symbolHoverStroke = Constantes.nodosymbolHoverStroke;

						avisoPlano.setIconHeight(Constantes.contenidoIconHeight);
						avisoPlano.setIconWidth(Constantes.contenidoIconWidth);
						avisoPlano.setIconAlign('center-center');

						avisoPlano.ENTIDAD = AVISO_CIUDADANO;
						that.notifications.push(avisoPlano);
						that.mapBeacons.set(AVISO_CIUDADANO.Id, avisoPlano);
					}
				});
			}
			return that.notifications;
		})
		.catch(function(err){
			return err;
		});
	}

	obtenerTIPOLOGIAS(that?) {
		that = this !== undefined ? this : that;
		const entityManager = that.entityManagerProvider;
		const includes = '';
		that.tipologias = [];
		that.tipologiaDefecto = null;
		return entityManager.getTIPOLOGIA_NODO()
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY TIPOLOGIAS');
			}
			else {
				console.log('TIPOLOGIAS CARGADAS CORRECTAMENTE = ' + entidades.length);
				that.tipologias = entidades;
				if (that.tipologias && that.tipologias.length > 0) {
					that.tipologias.sort( (one: any, two: any) => {
						return one.Nombre > two.Nombre ? 1 : -1;
					});
					that.tipologiaDefecto = that.tipologias[0];
				}
			}
		})
		.catch(function(err){
			return err;
		});
	}

	obtenerALA(id: String, that?) {
		that = this !== undefined ? this : that;
		const entityManager = that.entityManagerProvider;

		if (!that.verticalManager) {
			that.verticalManager = new VerticalManager();
			}

		let includes = 'SECCIONS.IDIOMAS, SECCIONS.NODOS.IDIOMAS, SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN.IDIOMAS, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO.IDIOMAS';
		includes = includes + ', SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';
		includes = includes + ', SECCIONS.NODOS.CONTENIDOS.CONTENIDO.TIPOLOGIA_CONTENIDO';
		includes = includes + ', SECCIONS.NODOS.CONTENIDOS.CONTENIDO.FOTOS';
		includes = includes + ', SECCIONS.NODOS.CONTENIDOS.CONTENIDO.SECCIONES';
		includes = includes + ', SECCIONS.NODOS.BALIZAS.BALIZA';
		includes = includes + ', SECCIONS.NODOS.AVISOS.AVISO_CIUDADANO';
		includes = includes + ', BALIZAS_SITUADAS_EN_ALA';
		includes = includes + ', NIVEL';

		return entityManager.getALA(undefined, includes)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY ALAS');
			}
			else {
				that.alasPortal = [];
				let i = 0;
				entidades.forEach(ala => {

					const aux = new AlaFormulario(ala);
					that.alasPortal.push(aux);
					if (ala.Id === id ){
						that.alaSeleccionada = entidades[i];
					}
					i += 1;
				});

				that.alasPortal.sort( function(a, b) {
					if ( a.ENTIDAD.NIVEL.NivelVertical === b.ENTIDAD.NIVEL.NivelVertical) {
						return a.Nomobre.localeCompare(b.Nomobre) ;
					}
					return a.ENTIDAD.NIVEL.NivelVertical - b.ENTIDAD.NIVEL.NivelVertical;
				});

				console.log('ALA CARGADA CORRECTAMENTE = ' + that.alaSeleccionada.Nomobre);
				return that.cargarPlano();
			}
		})
		.catch(function(err){
			throw err;
		});
	}

	obtenerALALazy(id: String, that?) {
		that = this !== undefined ? this : that;
		const entityManager = that.entityManagerProvider;

		if (!that.verticalManager) {
			that.verticalManager = new VerticalManager();
			}

		let includes = 'SECCIONS.IDIOMAS, SECCIONS.NODOS.IDIOMAS, SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN.IDIOMAS, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO.IDIOMAS';
		includes = includes + ', SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';
		includes = includes + ', SECCIONS.NODOS.CONTENIDOS.CONTENIDO.TIPOLOGIA_CONTENIDO';
		includes = includes + ', SECCIONS.NODOS.CONTENIDOS.CONTENIDO.FOTOS';
		includes = includes + ', SECCIONS.NODOS.CONTENIDOS.CONTENIDO.SECCIONES';
		includes = includes + ', SECCIONS.NODOS.BALIZAS.BALIZA';
		includes = includes + ', SECCIONS.NODOS.AVISOS.AVISO_CIUDADANO';
		includes = includes + ', BALIZAS_SITUADAS_EN_ALA';
		includes = includes + ', NIVEL';

		return entityManager.getALA(undefined, includes)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY ALAS');
			}
			else {
				that.alasPortal = [];
				let i = 0;
				entidades.forEach(ala => {

					const aux = new AlaFormulario(ala);
					that.alasPortal.push(aux);
					if (ala.Id === id ){
						that.alaSeleccionada = entidades[i];
					}
					i += 1;
				});

				that.alasPortal.sort( function(a, b) {
					if ( a.ENTIDAD.NIVEL.NivelVertical === b.ENTIDAD.NIVEL.NivelVertical) {
						return a.Nomobre.localeCompare(b.Nomobre) ;
					}
					return a.ENTIDAD.NIVEL.NivelVertical - b.ENTIDAD.NIVEL.NivelVertical;
				});

				console.log('ALA CARGADA CORRECTAMENTE = ' + that.alaSeleccionada.Nomobre);
				return that.cargarPlano();
			}
		})
		.catch(function(err){
			throw err;
		});
	}

	obtenerPERFIL_MOVILIDAD_CIUDADANO(that?) {
		that = this !== undefined ? this : that;
		const entityManager = that.entityManagerProvider;
		that.perfilesMovilidad = [];
		that.perfilesMovilidadDefecto = null;
		const idEspacio = that.authService.getIdEspacio();
		const predicado = new Predicate('IdEspacio', '==', idEspacio);
		return entityManager.getPERFIL_MOVILIDAD_CIUDADANO(predicado, undefined)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY PERFILES');
			}
			else {
				console.log('PERFILES CARGADOS CORRECTAMENTE = ' + entidades.length);
				that.perfilesMovilidad = entidades;
				if (that.perfilesMovilidad && that.perfilesMovilidad.length > 0) {
					that.perfilesMovilidadDefecto = that.perfilesMovilidad[0];
				}
			}
		})
		.catch(function(err){
			return err;
		});
	}


	public onSVGLoaded(event) {
		console.log('onSVGLoaded');
		console.log(event);
		const that = this;
		const secciones = new Array<SeccionPlano>();
		const nodos = new Array<NodoPlano>();
		const conexiones = new Array<ConexionPlano>();
		const contenidos =  new Array<ContenidoPlano>();
		const balizas = new Array<BeaconPlano>();
		this.mapSections = new Map<String, SeccionPlano>();
		this.mapNodes = new Map<String, NodoPlano>();
		this.mapLinks = new Map<String, ConexionPlano>();
		this.mapContents = new Map<String, ContenidoPlano>();
		this.mapBeacons = new Map<String, BeaconPlano>();
		this.mapNotifications = new Map<String, NotificacionPlano>();

		// SECCIONES
		this.alaSeleccionada.SECCIONS.forEach(seccion => {
			if (!this.seccionDefecto || !seccion.CoordenadasPoligono) {
				this.seccionDefecto = seccion;
			}
			const seccionCoordenadasPoligono: Array<Array<number>> = (!seccion.CoordenadasPoligono ? null : JSON.parse(seccion.CoordenadasPoligono));
			const seccionPlano = new SeccionPlano(seccion.Id, seccion.Nombre, seccionCoordenadasPoligono, seccion.ALA.PuntosSeccionScale , seccion.ALA.AristaSeccionScale);
			seccionPlano.ENTIDAD = seccion;
			seccionPlano.ENTIDAD.Color = seccionPlano.ENTIDAD.Color ? seccionPlano.ENTIDAD.Color : 'rgba(0,0,0,1)';
			const arrayColor = seccionPlano.ENTIDAD.Color.split('rgba(')[1].split(')')[0].split(',');
			const objetoColor =  {r: arrayColor[0], g: arrayColor[1], b: arrayColor[2], a: arrayColor[3]};
			const arrayColorHover = Constantes.seccionHoverFill.split('rgba(')[1].split(')')[0].split(',');
			const objetoColorHover  =  {r: arrayColorHover[0], g: arrayColorHover[1], b: arrayColorHover[2], a: arrayColorHover[3]};
			// Creamos el color hover de la seccion con el alfa del color de la seccion en reposo
			const seccionHoverColor = 'rgba(' + objetoColorHover.r + ',' + objetoColorHover.g + ','  + objetoColorHover.b + ',' + objetoColor.a + ')';
			// Relleno Seccion
			seccionPlano.fill  = seccionPlano.ENTIDAD.Color;		// Reposo
			seccionPlano.hoverFill = seccionHoverColor;	// Hover
			// Arista Seccion
			seccionPlano.stroke = seccionPlano.ENTIDAD.Color;					// Reposo
			seccionPlano.hoverStroke = Constantes.seccionHoverStroke;	// Hover
			// Ancho
			seccionPlano.strokeWidth = Constantes.seccionStrokeWidth;

			this.mapSections.set(seccion.Id, seccionPlano);

			// NODOS
			seccion.NODOS.forEach(nodo => {
				//  const icono = 'assets/planos/iconos/' + 'wifi.png';
				if (this.permisos.Mapa_plano_nodo !== 0) {
					let icono = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-de-paso.svg';
					if (nodo.TIPOLOGIA_NODO) {
						if ( nodo.TIPOLOGIA_NODO) {
							icono = nodo.TIPOLOGIA_NODO.IconoRepresentacion;
						}
						else{
							console.log('1.- NO TIPOLOGIA NODO');
						}
					}
					const nodoCoordenadasPoligono: Array<Array<number>> = (!nodo.CoordenadaPoligono ? null : JSON.parse(nodo.CoordenadaPoligono));
					const nodoPlano = new NodoPlano(nodo.Id, nodo.Nombre, nodo.X, nodo.Y, icono, nodoCoordenadasPoligono, nodo.SECCION.ALA.IconoNodoScale);
					nodoPlano.symbolStroke =  Constantes.nodoSymbolStroke;
					nodoPlano.symbolFill =   Constantes.nodoSymbolFill;
					nodoPlano.symbolHoverFill = Constantes.nodosymbolHoverFill;
					nodoPlano.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
					nodoPlano.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth;
					nodoPlano.sectionHoverFill =   Constantes.nodoSectionHoverFill;
					nodoPlano.sectionHoverStroke =   Constantes.nodoSectionHoverStroke;
					nodoPlano.symbolSize =   Constantes.nodoSymbolSize;
					nodoPlano.setIconHeight(Constantes.nodoIconHeight);
					nodoPlano.setIconWidth(Constantes.nodoIconWidth);
					nodoPlano.setNorotate(false);
					// nodoPlano.setRotation(90);
					nodoPlano.ENTIDAD = nodo;

					nodos.push(nodoPlano);
					this.mapNodes.set(nodo.Id, nodoPlano);
				}
				// CONEXIONES
				if (this.permisos.Mapa_plano_conexion !== 0) {
					// CONEXION ORIGEN
					nodo.CONEXIONS_NODOS_ORIGEN.forEach(conexion => {
						if (!this.mapLinks.has(conexion.Id)) {
							const coordenadasCamino: Array<Array<number>> = (!conexion.CoordenadasCamino ? null : JSON.parse(conexion.CoordenadasCamino));
							const conexionPlano = new ConexionPlano(conexion.Id, coordenadasCamino, conexion.IdNodoOrigen, conexion.IdNodoDestino, seccion.ALA.PuntosConexionScale , seccion.ALA.ConexionScale);
							conexionPlano.ENTIDAD = conexion;
							if (conexion.CortadoTemporalmente){
								// conexionPlano.fill  = Constantes.conexionFill_CORTADO;
								conexionPlano.stroke = Constantes.conexionStroke_CORTADO;
								conexionPlano.strokeWidth = Constantes.conexionStrokeWidth_CORTADO;
							}
							else{
								// conexionPlano.fill  = Constantes.conexionFill;
								conexionPlano.stroke = Constantes.conexionStroke;
								conexionPlano.strokeWidth = Constantes.conexionStrokeWidth;
								conexionPlano.lineHoverStroke = Constantes.conexionsymbolHoverStroke;
							}
							conexiones.push(conexionPlano);
							this.mapLinks.set(conexion.Id, conexionPlano);
						}
					});
					// CONEXION DESTINO
					nodo.CONEXIONS_NODOS_DESTINO.forEach(conexion => {
						if (!this.mapLinks.has(conexion.Id)) {
							const coordenadasCamino: Array<Array<number>> = (!conexion.CoordenadasCamino ? null : JSON.parse(conexion.CoordenadasCamino));
							const conexionPlano = new ConexionPlano(conexion.Id, coordenadasCamino, conexion.IdNodoOrigen, conexion.IdNodoDestino, conexion.NodoOrigen.SECCION.ALA.PuntosConexionScale, conexion.NodoOrigen.SECCION.ALA.ConexionScale);
							conexionPlano.ENTIDAD = conexion;
							if (conexion.CortadoTemporalmente){
								// conexionPlano.fill  = Constantes.conexionFill_CORTADO;
								conexionPlano.stroke = Constantes.conexionStroke_CORTADO;
								conexionPlano.strokeWidth = Constantes.conexionStrokeWidth_CORTADO;
								conexionPlano.lineHoverStroke = Constantes.conexionsymbolHoverStroke_CORTADO;
							}
							else{
								// conexionPlano.fill  = Constantes.conexionFill;
								conexionPlano.stroke = Constantes.conexionStroke;
								conexionPlano.strokeWidth = Constantes.conexionStrokeWidth;
								conexionPlano.lineHoverStroke = Constantes.conexionsymbolHoverStroke;
							}
							conexiones.push(conexionPlano);
							this.mapLinks.set(conexion.Id, conexionPlano);
						}
					});
				}
				// CONTENIDOS
				if (this.permisos.Mapa_plano_contenido !== 0 ) {
					const promises: any[] = [];
					const token = this.authService.getToken();
					nodo.CONTENIDOS.forEach(cont => {
						const contenido = new Contenido().fromENTIDAD(cont.CONTENIDO);
						if (contenido.Titulo === '') {
							console.log('CONTENIDO VACIO id nodo_has_contenido = ' + cont.Id);
						}
						const contenidoPlano =	this.setContenidoPlano(contenido);
						if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
							contenido.Imagen = this.authService.getFotoPorDefecto();
						}

						this.mapContents.set(contenido.Id, contenidoPlano);

					});
				}
				// NOTIFICACION
				nodo.AVISOS.forEach(NODO_has_AVISO => {
					const AVISO_CIUDADANO = NODO_has_AVISO.AVISO_CIUDADANO;
					if (AVISO_CIUDADANO.NODOS.length > 0) {
						const avisoPlano = new NotificacionPlano(AVISO_CIUDADANO.Id, AVISO_CIUDADANO.Titulo, AVISO_CIUDADANO.X, AVISO_CIUDADANO.Y, 'assets/itsoft/IconosSVG/email.svg', null, nodos[0].getIconScale());
						avisoPlano.setX(AVISO_CIUDADANO.X);
						avisoPlano.setY(AVISO_CIUDADANO.Y);

						avisoPlano.setSimbolo('assets/itsoft/IconosSVG/email.svg');
						avisoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
						avisoPlano.symbolFill = Constantes.contenidoSymbolFill;
						avisoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
						avisoPlano.symbolSize = Constantes.contenidoSymbolSize;

						avisoPlano.sectionHoverFill =   Constantes.nodoSectionHoverFill_SELECT;
						avisoPlano.sectionHoverStroke =   Constantes.nodoSectionHoverStroke_SELECT;
						avisoPlano.symbolHoverFill = Constantes.nodosymbolHoverFill;
						avisoPlano.symbolHoverStroke = Constantes.nodosymbolHoverStroke;

						avisoPlano.setIconHeight(Constantes.contenidoIconHeight);
						avisoPlano.setIconWidth(Constantes.contenidoIconWidth);
						avisoPlano.setIconAlign('center-center');

						avisoPlano.ENTIDAD = AVISO_CIUDADANO;
						this.notifications.push(avisoPlano);
						this.mapNotifications.set(AVISO_CIUDADANO.Id, avisoPlano);


					}
				});
			});
		});
		conexiones.forEach(conexionPlano => {
			const nodoOrigen: NodoPlano = this.mapNodes.get(conexionPlano.getIdNodoOrigen());
			const nodoDestino: NodoPlano = this.mapNodes.get(conexionPlano.getIdNodoDestino());
			conexionPlano.setNodoOrigen(nodoOrigen);
			if (nodoOrigen !== undefined) {
				nodoOrigen.conexiones.push(conexionPlano);
			}
			conexionPlano.setNodoDestino(nodoDestino);
			if (nodoDestino !== undefined) {
				nodoDestino.conexiones.push(conexionPlano);
			}
		});
		nodos.forEach(nodoPlano => {
			nodoPlano.refreshRutasConexionesBackup();
		});

		if (this.permisos.Mapa_plano_balizas !== 0){
			this.alaSeleccionada.BALIZAS_SITUADAS_EN_ALA.forEach(beacon => {
				// BEACONS
				let icono;
				if(beacon.TIPOLOGIA_BALIZA.esBeacon){
					icono = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-baliza.svg';
				}
				if(beacon.TIPOLOGIA_BALIZA.esSniffer){
					icono = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-snifer.svg';
				}
				if(beacon.TIPOLOGIA_BALIZA.esTag){
					icono = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-tag.svg';
				}

				const nodoPlano: NodoPlano = this.mapNodes.values().next().value;
				const beaconPlano = new BeaconPlano(beacon.Id, beacon.IdHardware, beacon.X, beacon.Y, icono, null, nodoPlano.getIconScale());
				beaconPlano.symbolStroke =  Constantes.nodoSymbolStroke;
				beaconPlano.symbolFill =   Constantes.nodoSymbolFill;
				beaconPlano.symbolHoverFill = Constantes.nodosymbolHoverFill;
				beaconPlano.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
				beaconPlano.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth;
				beaconPlano.sectionHoverFill =   Constantes.nodoSectionHoverFill;
				beaconPlano.sectionHoverStroke =   Constantes.nodoSectionHoverStroke;
				beaconPlano.symbolSize =   Constantes.nodoSymbolSize;
				beaconPlano.setIconHeight(Constantes.nodoIconHeight);
				beaconPlano.setIconWidth(Constantes.nodoIconWidth);
				beaconPlano.setNorotate(false);

				beaconPlano.ENTIDAD = beacon;
				this.mapBeacons.set(beacon.Id, beaconPlano);
			});
		}

		this.mostrarNodos = true;
		this.mostrarSecciones = true;
		this.mostrarTramos = true;
		this.mostrarContenidos = true;
		this.mostrarBalizas = true;
		this.mostrarNotificaciones = true;

		this.asignarSections();
		this.asignarContents();
		this.asignarBeacons();
		this.asignarLinks(conexiones);
		this.asignarNodes(nodos);
		// this.asignarAvisos(this.notifications);
		this.asignarNotificaciones();
	}
	public onNodeMoved(event) {
		// console.log('onNodeMoved');
		const nodoPlano = this.mapNodes.get(event.id);
		this.nodoEdicion.X = this.nodoEdicion.NODO_PLANO.getX();
		this.nodoEdicion.Y = this.nodoEdicion.NODO_PLANO.getY();
		//  this.nodoEdicion.X = event.x; //  nodoPlano.getX();
		//  this.nodoEdicion.Y = event.y; //  nodoPlano.getY();
		// console.log(this.nodoEdicion.X + ' , ' + this.nodoEdicion.Y);
		//  Calcular la nueva seccion...
		let seccionDetectada = this.seccionDefecto;
		this.sections.forEach((seccionPlano: SeccionPlano) => {
			if (seccionPlano.getCoordenadasPoligono()) {
				if (this.pointInPolygon([this.nodoEdicion.X as number, this.nodoEdicion.Y as number], seccionPlano.getCoordenadasPoligono())) {
					seccionDetectada = seccionPlano.ENTIDAD;
				}
			}
		});
		this.nodoEdicion.IdSeccion = seccionDetectada.Id;
		this.nodoEdicion.NombreSeccion = seccionDetectada.Nombre;
	}
	public onSVGClicked(event) {
		const that = this;
		let nodoGuardado: any = null;
		let balizaGuardada: any = null;
		this.comprobarConversionCoordenadas(event);
		if(that.displayDialogContenido){
			that.displayDialogContenido = false;
		}
		if ((this.permisos.Mapa_plano_nodo === 2  && this.permisos.Mapa_plano_nodo_formulario !== 0) && (this.estadoEdicion === 'NODO_CREAR')) {
			that.spinner.style.display = 'inherit';
			return this.entityManagerProvider.newNodo()
			.then(function(oNodo) {
				oNodo.IdEntidad = that.authService.getIdEntidad();
				oNodo.IDIOMAS.forEach(NODO_IDIOMA => {
					const aux = that.nodoEdicion.Idiomas.get(NODO_IDIOMA.IDIOMA.Codigo);
					NODO_IDIOMA.Nombre = that.translate.instant('Mapas.nuevonodo');
					NODO_IDIOMA.Descripcion = '';
					if (NODO_IDIOMA.IDIOMA.Default) {
						oNodo.Nombre = NODO_IDIOMA.Nombre ? NODO_IDIOMA.Nombre : '';
						oNodo.Descripcion = NODO_IDIOMA.Descripcion ? NODO_IDIOMA.Descripcion : '';
					}
				});
				oNodo.X = event.mp[0];
				oNodo.Y = event.mp[1];
				if (that.mapSections.get(event.id)) {
					oNodo.IdSeccion = that.mapSections.get(event.id).getId();
				}
				else{
					oNodo.IdSeccion = that.seccionDefecto.Id;
				}
				oNodo.IdTipologia = that.tipologiaDefecto.Id;
				nodoGuardado = oNodo;
				return that.entityManagerProvider.saveChanges();
			})
			.then(function(msg) {
				const oNodo = nodoGuardado;
				let icono = 'assets/planos/iconos/' + 'wifi.png';
				if ( oNodo.TIPOLOGIA_NODO) {
					icono = oNodo.TIPOLOGIA_NODO.IconoRepresentacion;
				}
				else{
					console.log('2.- NO TIPOLOGIA NODO');
				}
				const nodoCoordenadasPoligono: number[][] = (!oNodo.CoordenadasPoligono ? null : JSON.parse(oNodo.CoordenadasPoligono));
				const nodoPlano = new NodoPlano(oNodo.Id, oNodo.Nombre, oNodo.X, oNodo.Y, icono, nodoCoordenadasPoligono, oNodo.SECCION.ALA.IconoNodoScale);
				nodoPlano.setNorotate(false);
				// nodoPlano.setRotation(90);
				nodoPlano.symbolStroke =  Constantes.nodoSymbolStroke;
				nodoPlano.symbolFill =   Constantes.nodoSymbolFill;
				nodoPlano.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth;
				nodoPlano.sectionHoverFill =   Constantes.nodoSectionHoverFill;
				nodoPlano.sectionHoverStroke =   Constantes.nodoSectionHoverStroke;
				nodoPlano.symbolHoverFill = Constantes.nodosymbolHoverFill;
				nodoPlano.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
				nodoPlano.symbolSize =   Constantes.nodoSymbolSize;
				nodoPlano.setIconHeight(Constantes.nodoIconHeight);
				nodoPlano.setIconWidth(Constantes.nodoIconWidth);
				nodoPlano.ENTIDAD = oNodo;
				that.estadoEdicion = 'NODO_SELEC';
				that.displayDialogEditarNodo = true;
				that.msgs = [];
				that.nodoEdicion = new NodoFormulario().fromNodoPlano(nodoPlano);
				that.nodoEdicion.Idiomas = that.idiomaService.newMapNodoIdiomas(this.idiomas);
				return that.nodoEdicion;
			})
			.then(function(){
				that.spinner.style.display = 'none';
			})
			.catch(function(e) {
				that.spinner.style.display = 'none';
				console.log('Excepcion creando nodo = ' + e.toString());
				return false;
			});
		}
		else if ((this.permisos.Mapa_plano_seccion === 2  && this.permisos.Mapa_plano_seccion_formulario !== 0) && (this.estadoEdicion === 'SECCION_CREAR')) {
			if (!this.seccionEdicion || !this.seccionEdicion.SECCION_PLANO || !this.seccionEdicion.SECCION_PLANO.getCoordenadasPoligono()) {
				const coordenadasIniciales = [ [event.mp[0], event.mp[1]] , [event.mp[0], event.mp[1]] ];
				const seccionPlano = new SeccionPlano('', 'Nueva Sección', coordenadasIniciales, 1, 1);
				seccionPlano.setMostrarConectores(true);
				this.displayDialogCrearSeccion = true;
				this.seccionEdicion = new SeccionFormulario(this.idAla).fromSeccionPlano(seccionPlano);
				this.seccionEdicion.Nombre = seccionPlano.getNombre() as string;
				let colorSECCION;
				if (seccionPlano.ENTIDAD) {
					seccionPlano.ENTIDAD.Color = seccionPlano.ENTIDAD.Color ? seccionPlano.ENTIDAD.Color : 'rgba(64,255,0,0.3)';
					colorSECCION = seccionPlano.ENTIDAD.Color;
				}
				else{
					colorSECCION = 'rgba(64,255,0,0.3)';
				}
				const arrayColor = colorSECCION.split('rgba(')[1].split(')')[0].split(',');
				const objetoColor =  {r: arrayColor[0], g: arrayColor[1], b: arrayColor[2], a: arrayColor[3]};
				const arrayColorHover = Constantes.seccionHoverFill.split('rgba(')[1].split(')')[0].split(',');
				const objetoColorHover  =  {r: arrayColorHover[0], g: arrayColorHover[1], b: arrayColorHover[2], a: arrayColorHover[3]};
				// Creamos el color hover de la seccion con el alfa del color de la seccion en reposo
				const seccionHoverColor = 'rgba(' + objetoColorHover.r + ',' + objetoColorHover.g + ','  + objetoColorHover.b + ',' + objetoColor.a + ')';
				// Relleno Seccion
				seccionPlano.fill  = colorSECCION;	// Reposo
				seccionPlano.hoverFill = seccionHoverColor;	// Hover
				// Arista Seccion
				seccionPlano.stroke = colorSECCION;		// Reposo
				seccionPlano.hoverStroke = Constantes.seccionHoverStroke;	// Hover
				// Ancho
				seccionPlano.strokeWidth = Constantes.seccionStrokeWidth;
				this.sections.push(seccionPlano);
			}
			else {
				const coordenadas = this.seccionEdicion.SECCION_PLANO.getCoordenadasPoligono();
				coordenadas.splice(coordenadas.length - 1, 0, event.mp);
				this.seccionEdicion.SECCION_PLANO.setCoordenadasPoligono(coordenadas);
			}
			this.asignarSections(this.sections);
		}
		else if ((this.permisos.Mapa_plano_nodo === 2  && this.permisos.Mapa_plano_nodo_formulario !== 0) && (this.estadoEdicion === 'BALIZA_CREAR')) {
				that.spinner.style.display = 'inherit';
				return this.entityManagerProvider.newBALIZA()
				.then(function(oBaliza) {

					const idEspacio = that.authService.getIdEspacio();
					oBaliza.EspacioPertenencia = idEspacio;
					const tipoBeacon = that.tipologiasBaliza.find( t => t.esBeacon);
					oBaliza.IdTipologia = tipoBeacon.Id;
					oBaliza.IdAlaPlano = that.idAla;
					oBaliza.X = event.mp[0];
					oBaliza.Y = event.mp[1];
					oBaliza.FechaAlta =  new Date();
					oBaliza.FechaBaja =  new Date();
					oBaliza.FechaBaja =  (d => d.setFullYear(d.getFullYear() + 50))(new Date);
					oBaliza.TimestampLecturaBateria = (d => d.setFullYear(d.getFullYear() + 1))(new Date(0));

					balizaGuardada = oBaliza;

					return that.entityManagerProvider.saveChanges();
				})
				.then(function(msg) {


					const icono =  'assets/itsoft/IconosSVG/SVG/' + 'nodo-baliza.svg';
					const beacon = balizaGuardada;

					const nodoPlano: NodoPlano = that.mapNodes.values().next().value;

					const beaconPlano = new BeaconPlano(beacon.Id, beacon.IdHardware, beacon.X, beacon.Y, icono, null, nodoPlano.getIconScale());
					beaconPlano.symbolStroke =  Constantes.nodoSymbolStroke;
					beaconPlano.symbolFill =   Constantes.nodoSymbolFill;
					beaconPlano.symbolHoverFill = Constantes.nodosymbolHoverFill;
					beaconPlano.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
					beaconPlano.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth;
					beaconPlano.sectionHoverFill =   Constantes.nodoSectionHoverFill;
					beaconPlano.sectionHoverStroke =   Constantes.nodoSectionHoverStroke;
					beaconPlano.symbolSize =   Constantes.nodoSymbolSize;
					beaconPlano.setIconHeight(Constantes.nodoIconHeight);
					beaconPlano.setIconWidth(Constantes.nodoIconWidth);
					beaconPlano.setNorotate(false);

					beaconPlano.ENTIDAD = beacon;
					that.mapBeacons.set(beacon.Id, beaconPlano);

					that.estadoEdicion = 'BEACON_SELEC';
					that.displayDialogBaliza = true;
					that.msgs = [];
					that.balizaEdicion = new BalizaFormulario().fromBeaconPlano(beaconPlano);

					that.beacons.push(beaconPlano);

					this.asignarBeacons(this.beacons);

					return that.balizaEdicion;
				})
				.then(function(){
					that.spinner.style.display = 'none';
				})
				.catch(function(e) {
					that.spinner.style.display = 'none';
					console.log('Excepcion creando nodo = ' + e.toString());
					return false;
				});
		}
		else{
			this.todosHide();
		}
	}
	public onSeccionCreada(event){
		const that = this;
		if (!event){
			this.displayDialogCrearSeccion = false;
			that.spinner.style.display = 'none';
			return;
		}
		if (this.seccionEdicion.SECCION_PLANO.getCoordenadasPoligono().length < 4){
			that.spinner.style.display = 'none';
			return;
		}
		this.displayDialogCrearSeccion = false;
		this.crearSeccion(event)
		.then(function(){
			that.spinner.style.display = 'none';
		});
	}
	public onSectionDblClicked(event) {

	}
	public onEyedropperSelected(eyedropperSelected){
		if (eyedropperSelected){
			this.cursorPointer = 'copy';
		}else{
			const that = this;
			setTimeout(function(){
				that.cursorPointer = '';
			}, 1000);
		}
	}
	public crearSeccion(event){
		const that = this;
		const seccionInicial: any = this.seccionEdicion;
		let seccionGuardada: any = null;
		if (this.estadoEdicion === 'SECCION_CREAR') {

			if (this.seccionEdicion && this.seccionEdicion.SECCION_PLANO && this.seccionEdicion.SECCION_PLANO.getCoordenadasPoligono()) {
				return this.entityManagerProvider.newSECCION()
				.then(function(oSeccion) {
					oSeccion.IdAla = seccionInicial.IdAla;
					// oSeccion.Nombre = that.seccionEdicion.Nombre;
					// oSeccion.Descripcion = that.seccionEdicion.Descripcion;
					oSeccion.IDIOMAS.forEach(SECCION_IDIOMA => {
						// const aux = that.seccionEdicion.Idiomas.get(SECCION_IDIOMA.IDIOMA.Codigo);
						SECCION_IDIOMA.Nombre = that.translate.instant('Mapas.nuevaSeccion');
						SECCION_IDIOMA.Descripcion = '';
						if (SECCION_IDIOMA.IDIOMA.Default) {
							oSeccion.Nombre = SECCION_IDIOMA.Nombre ? SECCION_IDIOMA.Nombre : '';
							oSeccion.Descripcion = SECCION_IDIOMA.Descripcion ? SECCION_IDIOMA.Descripcion : '';
						}
					});
					oSeccion.FechaAlta = new Date();
					oSeccion.CoordenadasPoligono = JSON.stringify(seccionInicial.SECCION_PLANO.getCoordenadasPoligono());
					seccionGuardada = oSeccion;
					return that.entityManagerProvider.saveChanges();
				})
				.then(function(msg) {
					that.seccionEdicion = seccionInicial;
					const oSeccion = seccionGuardada;
					const seccionPlano = new SeccionPlano(oSeccion.Id, oSeccion.Nombre, JSON.parse(oSeccion.CoordenadasPoligono), oSeccion.ALA.PuntosSeccionScale , oSeccion.ALA.AristaSeccionScale);
					seccionPlano.ENTIDAD = oSeccion;
					that.estadoEdicion = 'SECCION_SELEC';
					that.displayDialogEditarSeccion = true;
					/*if(that.seccionEdicion.FechaBaja){
						that.apareceBoton = true;
					}*/
					that.msgs = [];
					that.mapSections.set(oSeccion.Id, seccionPlano);
					that.seccionEdicion = new SeccionFormulario().fromSeccionPlano(seccionPlano); //  event.id;
					that.seccionEdicion.SECCION_PLANO.setMostrarConectores(true);
					// that.seccionEdicion.Idiomas = that.idiomaService.newMapSeccionIdiomas(that.idiomas);
					that.appComponent.showSuccess(that.translate.instant('Mapas.seccioncreadaok'));
					that.reasignarNodosSeccion(that.seccionEdicion);
					that.reasignarContenidosSeccion(that.seccionEdicion);
					that.limpiarSeccionesFantasma();
					that.sections.push(seccionPlano);
					// that.onSVGLoaded(null);
					return msg;
				})
				.catch(function(e) {
					that.tramoNodoOrigen = null;
					that.tramoNodoDestino = null;
					that.estadoEdicion = '';
					that.appComponent.showError(that.translate.instant('Mapas.seccioncreadaerror') + e.toString());
					console.log('Exception: ' + e.toString());
					//  that.appComponent.showError(e);
					return false;
				});
			}
		}
	}
	limpiarSeccionesFantasma(){
		// Eliminar del plano seccion con id: 'UUID-'
		const elem = document.getElementById('UUID-');
		if (elem !== null && elem !== undefined) {
			elem.parentNode.removeChild(elem);
		}
		// Eliminar del array de secciones que se pintaran en el plano las secciones con id==''
		this.sections = this.sections.filter( x => x.getId() !== '');
		if	(this.estadoEdicion === ''){
			this.desOcultarElementosEnNoEdicion();
		}
	}
	protected pointInPolygon(point: number[], polygon: number[][]): boolean {
        let inside = false;
        const x = point[0], y = point[1];
		for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
			const xi = polygon[i][0], yi = polygon[i][1], xj = polygon[j][0], yj = polygon[j][1];
			const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
			if (intersect) { inside = !inside; }
		}
        return inside;
	}
	protected calcIsInsideThickLineSegment(line1, line2, pnt, lineThickness): boolean {
		const L2 = (((line2.x - line1.x) * (line2.x - line1.x)) + ((line2.y - line1.y) * (line2.y - line1.y)));
		if (L2 === 0) { return false; }
		const r = (((pnt.x - line1.x) * (line2.x - line1.x)) + ((pnt.y - line1.y) * (line2.y - line1.y))) / L2;
		if (r < 0) {
		  return (Math.sqrt(((line1.x - pnt.x) * (line1.x - pnt.x)) + ((line1.y - pnt.y) * (line1.y - pnt.y))) <= lineThickness);
		} else if ((0 <= r) && (r <= 1)) {
		  const s = (((line1.y - pnt.y) * (line2.x - line1.x)) - ((line1.x - pnt.x) * (line2.y - line1.y))) / L2;
		  return (Math.abs(s) * Math.sqrt(L2) <= lineThickness);
		} else {
		  return (Math.sqrt(((line2.x - pnt.x) * (line2.x - pnt.x)) + ((line2.y - pnt.y) * (line2.y - pnt.y))) <= lineThickness);
		}
	}
	protected obtenerIndiceSegmento(mp: number[], coordenadas: number[][]): number {
		let indice = -1;
		console.log('coordenadas ' + coordenadas.length);
		for (let i = 0; i < coordenadas.length - 1; i++) {
			const la: any = { x: coordenadas[i][0], y: coordenadas[i][1] };
			const t: any = { x: mp[0], y: mp[1] };
			const lb: any = { x: coordenadas[i + 1][0], y: coordenadas[i + 1][1] };
			if (this.calcIsInsideThickLineSegment(la, lb, t, 20)) {
				indice = i;
				break;
			}
		}
		return indice;
	}
	private reajusteCoordenadas(_coord){
		if (_coord.length < 4){
			return;
		}
		if ( _coord[0][0] !== _coord[_coord.length - 1 ][0] ||
			_coord[0][1] !== _coord[_coord.length - 1 ][1]
		){
			_coord[_coord.length - 1 ][0] = _coord[0][0];
			_coord[_coord.length - 1 ][1] = _coord[0][1];
		}
		this.seccionEdicion.SECCION_PLANO.setCoordenadasPoligono(_coord);
		let asignado = false;
		for (const _k in this.sections){
			if (this.sections[_k].getId() === this.seccionEdicion.SECCION_PLANO.getId()){
				asignado = true;
				this.sections[_k] = this.seccionEdicion.SECCION_PLANO;
				break;
			}
		}
		if	(!asignado){
			this.sections.push(this.seccionEdicion.SECCION_PLANO);
		}

		this.asignarSections(this.sections);

		console.log(this.sections);
		console.log(this.seccionEdicion.SECCION_PLANO);
	}
	// TODO DCANETE: Revisar menu radial
	protected abrirMenuConectorSeccion(mp: number[], g: any, idx: number) {
		const menu_entries = [
			{ icon : 'assets/planos/fa/raw-svg/regular/trash-alt.svg', action: 'delete' }
		];
		const that = this;
		this.todosHide();

		const seccion: SeccionPlano = that.seccionEdicion.SECCION_PLANO;
		const coordenadas: number[][] = seccion.getCoordenadasPoligono();
		// console.log(coordenadas[idx]);
		mp[0] = coordenadas[idx][0] * this.mapaZoom;
		mp[1] = coordenadas[idx][1] * this.mapaZoom;
		this.mpClick = [mp[0], mp[1]];

		// mp[0] *= this.mapaZoom;
		// mp[1] *= this.mapaZoom;
		this.section_conector_menu = d3RadialMenu.d3RadialMenu()
		.scale(D3SCALEMENU).radius(D3RADIUSMENU).thickness(D3THICKNESSMENU).iconSize(D3ICONSIZEMENU)
		.entries(menu_entries)
		.on('click', function(action, menu) {
			if (action === 'delete') {
				if (idx >= 0 && coordenadas.length > idx && coordenadas.length > 4) {
					coordenadas.splice(idx, 1);
					that.reajusteCoordenadas(coordenadas);
				}else{
					that.appComponent.showInfo(that.translate.instant('Mapas.errorPocosNodosBorrar'));
				}
			}
		})
		.showMenu(g, mp, this.seccionEdicion.SECCION_PLANO);
	}
	protected abrirMenuSeccion(seccionPlano: SeccionPlano, mp: number[], g: any) {
		const section_entries = [
			// { icon : 'assets/planos/fa/raw-svg/regular/edit.svg', action: 'edit' },
			// { icon : 'assets/planos/fa/raw-svg/regular/trash-alt.svg', action: 'delete' },
			{ icon : 'assets/planos/fa/raw-svg/solid/code-branch.svg', action: 'divide' }
		];
		const that = this;
		this.todosHide();

		if (
			!this.seccionEdicion ||
			!this.seccionEdicion.SECCION_PLANO ||
			seccionPlano.getId() !== this.seccionEdicion.SECCION_PLANO.getId() ){
			return;
		}

		mp[0] *= this.mapaZoom;
		mp[1] *= this.mapaZoom;
		const _zoom_click = this.mapaZoom;

		this.section_segment_menu = d3RadialMenu.d3RadialMenu()
			.scale(D3SCALEMENU).radius(D3RADIUSMENU).thickness(D3THICKNESSMENU).iconSize(D3ICONSIZEMENU)
			.entries(section_entries)
			.on('click', function(action, menu) {
				if (action === 'divide') {
					const _mp = [ mp[0] / _zoom_click , mp[1] / _zoom_click ];
					const seccion: SeccionPlano = menu.data();
					const coordenadas: number[][] = seccion.getCoordenadasPoligono();
					const indice = that.obtenerIndiceSegmento(_mp, coordenadas);
					// console.log('indice = ' + indice);
					if (typeof(indice) !== 'undefined' && indice != null && indice >= 0) {
						coordenadas.splice(indice + 1, 0, _mp);

						that.reajusteCoordenadas(coordenadas);
					}
				}
			})
			.showMenu(g, mp, seccionPlano);

	}
	public onZoomChanged(_zoom){
		if (this.section_segment_menu){
			const _mpTest = [this.mpClick[0] * _zoom, this.mpClick[1] * _zoom];
			this.section_segment_menu.setOffset(_mpTest);
			this.section_segment_menu.redraw(this.section_segment_menu.entries);
		}
		if (this.section_conector_menu){
			const _mpTest = [this.mpClick[0] * _zoom, this.mpClick[1] * _zoom];
			this.section_conector_menu.setOffset(_mpTest);
			this.section_conector_menu.redraw(this.section_conector_menu.entries);
		}
		if (this.link_segment_menu){
			const _mpTest = [this.mpClick[0] * _zoom, this.mpClick[1] * _zoom];
			this.link_segment_menu.setOffset(_mpTest);
			this.link_segment_menu.redraw(this.link_segment_menu.entries);
		}
		this.mapaZoom = _zoom;
	}
	todosHide(){
		if (this.section_segment_menu){
			this.section_segment_menu.hide();
			this.section_segment_menu = null;
		}
		if (this.section_conector_menu){
			this.section_conector_menu.hide();
			this.section_conector_menu = null;
		}
		if (this.link_segment_menu) {
			this.link_segment_menu.hide();
			this.link_segment_menu = null;
		}
	}
	public onSectionConectorClicked(event){

		this.todosHide();
		this.abrirMenuConectorSeccion(event.mp, event.g_noZoom, event.idx);
	}
	public onSectionClicked(event) {
		this.mpClick = [event.mp[0] , event.mp[1]];
		this.todosHide();
		this.limpiarSeccionesFantasma();
		if ((this.permisos.Mapa_plano_seccion !== 0 && this.permisos.Mapa_plano_seccion_formulario !== 0) && (this.estadoEdicion === 'SECCION_SELEC' || this.estadoEdicion === '') && (!this.seccionEdicion || !this.seccionEdicion.Id)) {
			this.estadoEdicion = 'SECCION_SELEC';
			const seccionPlano = this.mapSections.get(event.id);
			this.resaltarSeccionSeleccionado(event.id);
			console.log('seccionPlano ' + seccionPlano);
			const seccionFormulario: SeccionFormulario = new SeccionFormulario(this.idAla).fromSeccionPlano(seccionPlano);
			seccionFormulario.SECCION_PLANO.setMostrarConectores(true);
			if (seccionFormulario.FechaBaja !== null){
				this.apareceBoton = true;
			}
			this.seccionEdicion = seccionFormulario;
			this.displayDialogEditarSeccion = true;

			this.msgs = [];
			this.seccionEdicion.Idiomas = this.idiomaService.getMapSeccionIdiomas(this.seccionEdicion.ENTIDAD.IDIOMAS);
			console.log('seccionEdicion ' + this.seccionEdicion);
			this.ocultarElementosEnNoEdicion(['mostrarSecciones']);
		}
		else if ((this.permisos.Mapa_plano_seccion !== 0 && this.permisos.Mapa_plano_seccion_formulario !== 0) && this.estadoEdicion === 'SECCION_SELEC' && this.seccionEdicion !== undefined) {
			// this.seccionEdicion.Idiomas = this.idiomaService.getMapSeccionIdiomas(this.seccionEdicion.ENTIDAD.IDIOMAS);
			const seccionPlano = this.mapSections.get(event.id);
			this.colorSeleccionado = '#00000';
			this.colorSeleccionado = seccionPlano.fill;
			console.log(event);
			this.abrirMenuSeccion(seccionPlano, event.mp, event.g_noZoom);
		}
		else {
			this.onSVGClicked(event);
		}
	}
	public onNodeClicked(event) {
		const nodoPlano = this.mapNodes.get(event.id);

		if (this.permisos.Mapa_plano_nodo === 2 && this.permisos.Mapa_plano_nodo_formulario !== 0){
			// Si estamos seleccionando un nodo como destino de una conexion portal limitamos que no se pueda conectar un nodo consigomismo
			/*
			if ((this.estadoEdicion === 'NODO_SELEC' || this.estadoEdicion === '') &&
					(this.nodoEdicion && this.nodoEdicion.Id ) &&
					(this.nodoEdicion.Id !== nodoPlano.ENTIDAD.Id)
				){
					*/
			if (this.estadoEdicion === 'PORTAL_CREAR') {
				this.tramoNodoOrigen = this.nodoEdicion.NODO_PLANO;
				this.tramoNodoDestino = this.mapNodes.get(event.id);

				const nodoDestino: NodoFormulario = new NodoFormulario().fromNodoPlano(nodoPlano);
				const nodoOrigen: NodoFormulario = this.nodoEdicion;

				if (!nodoDestino.ENTIDAD.EsPortal) {
					this.appComponent.showError(this.translate.instant('Mapas.noPortal'));
				}
				else{
					console.log('--- Creando Conexion entre: ');
					console.log('-------- Origen: ' + nodoOrigen.Nombre);
					console.log('-------- Destino: ' + nodoDestino.Nombre);
					const esPortal = true;
					this.crearConexionNodo(nodoPlano, esPortal)
					.then(() => {
						this.appComponent.showSuccess(this.translate.instant('Mapas.nodoSeleccionado'));
					});
				}

			}
			if ( 	(this.estadoEdicion === 'NODO_SELEC' || this.estadoEdicion === '')
				&& (!this.nodoEdicion || !this.nodoEdicion.Id))
			{

				this.estadoEdicion = 'NODO_SELEC';
				this.resaltarNodoSeleccionado(event.id);
				// const nodoPlano = this.mapNodes.get(event.id);
				nodoPlano.refreshRutasConexionesBackup();
				console.log('nodoPlano ' + nodoPlano);
				this.nodoEdicion = new NodoFormulario().fromNodoPlano(nodoPlano); //  event.id;
				this.nodoEdicion.ENTIDAD.EsPortal = this.nodoEdicion.ENTIDAD.EsPortal;
				this.nodoEdicion.ENTIDAD.EsEntrada = this.nodoEdicion.ENTIDAD.EsEntrada;
				this.displayDialogEditarNodo = true;

				this.balizasResaltar = this.nodoEdicion.balizas.map( x => this.beacons.find(y => y.getId() === x.Id));
				this.resaltarBalizasSeleccionadas();

				this.msgs = [];
				this.nodoEdicion.Idiomas = this.idiomaService.getMapNodoIdiomas(this.nodoEdicion.ENTIDAD.IDIOMAS);
			}
			else if (this.estadoEdicion === 'TRAMO_CREAR' && (!this.tramoNodoOrigen)) {
				this.tramoNodoOrigen = nodoPlano;
				this.appComponent.showInfo(this.translate.instant('Mapas.seleccionenodoconectar'));
			}
			else if (this.estadoEdicion === 'TRAMO_CREAR' && (this.tramoNodoOrigen)) {
				const esPortal = false;
				this.crearConexionNodo(nodoPlano, esPortal);
			}
		}
		console.log('PRE');
	}
	public onBeaconClicked(event){
		console.log('onBeaconClicked ' + event);
		console.log('event.id ' + event.id);
		if (this.permisos.Mapa_plano_balizas === 2  && this.permisos.Mapa_plano_baliza_formulario !== 0){
			const beaconPlano = this.mapBeacons.get(event.id);
			console.log('ESTADO EDICION: ' + this.estadoEdicion );
			if (this.estadoEdicion === '') {

				const encontrado = this.balizasResaltar.find( x => x.getId() === event.id);
				if (!encontrado) {
					this.balizasResaltar.push(beaconPlano);
				}
				else{
					this.balizasResaltar = this.balizasResaltar.filter( x => x.getId() !== event.id);
				}

				this.resaltarBalizasSeleccionadas();

			}

			// Si estamos seleccionando una Baliza como destino de una conexion portal limitamos que no se pueda conectar un nodo consigomismo
			if ( (this.estadoEdicion === 'BALIZA_SELEC' || this.estadoEdicion === '')
				&& (!this.balizaEdicion || !this.balizaEdicion.Id)){
				this.estadoEdicion = 'BALIZA_SELEC';
				// this.resaltarContenidoSeleccionado(event.id);
				console.log('beaconPlano ' + beaconPlano);
				this.balizaEdicion = new BalizaFormulario().fromBeaconPlano(beaconPlano); // new Contenido(contenidoPlano); //  event.id;
				this.displayDialogBaliza = true;
				this.msgs = [];
			}
			if (this.estadoEdicion === 'NODO_SELEC') {
				this.balizaAsociarSeleccionada = new BalizaFormulario().fromBeaconPlano(beaconPlano);

				const encontrado = this.balizasResaltar.find( x => x.getId() === event.id);
				if (!encontrado) {
					this.balizasResaltar.push(beaconPlano);
				}
				else{
					this.balizasResaltar = this.balizasResaltar.filter( x => x.getId() !== event.id);
				}

				this.resaltarBalizasSeleccionadas();

			}
			else{
				console.log('Ya estamos editando la posicion de un contenido');
			}
			console.log('POST BALIZA_SELEC');
		}
	}
	onBeaconMoved(event){

		console.log('onBeaconMoved');
		console.log('---------------------------------');
		const beaconPlano = this.mapBeacons.get(event.id);
		const click_X = this.balizaEdicion.BALIZA_PLANO.getX();
		const click_Y = this.balizaEdicion.BALIZA_PLANO.getY();
		console.log(this.balizaEdicion.X + ' , ' + this.balizaEdicion.Y);

		this.balizaEdicion.X = click_X;
		this.balizaEdicion.Y = click_Y;
	}
	onBeaconGuardado(event){
		console.log(event)
		const result = event.result;
		if (result === true) {
			console.log('TRUE')
			this.displayDialogContenido = false;
			this.onFormularioBalizaCerrado(undefined);
			this.reasignarContenidos();

			this.appComponent.showSuccess(this.translate.instant('Mapas.balizaguardadook'));
			//this.onSVGLoaded(event);
		}
		else {
			console.log('aqui')
			this.appComponent.showError(this.translate.instant('Mapas.balizaguardadoerror'));
			this.onFormularioBalizaCerrado(undefined);
		}
	}
	onBeaconEliminado(event){
		const result = event.result;
		const balizaFormulario: BalizaFormulario = event.element;
		if (result === true) {
			if (this.mapBeacons && this.mapBeacons.has(balizaFormulario.Id)) {
				// Lo añado si no estaba para que el componente plano detecte cambios en los nodos
				this.mapBeacons.set(balizaFormulario.Id, balizaFormulario.BALIZA_PLANO);
				this.mapBeacons.get(balizaFormulario.Id).setEliminado(true);
				this.mapBeacons.delete(balizaFormulario.Id);
			}
			this.displayDialogEditarNodo = false;
			this.onFormularioBalizaCerrado(undefined);
			this.appComponent.showSuccess(this.translate.instant('Mapas.balizaeliminadook'));
		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.balizaeliminadoerror'));
		}
	}
	public onFormularioBalizaAbierto (evento){
	}
	public onFormularioBalizaCerrado(event){

		console.log('onFormularioBalizaCerrado');

		this.balizasResaltar = [];
		this.desmarcarBalizas();

		if (this.displayDialogBaliza) { //  Descartado
			if (this.balizaEdicion.ENTIDAD) {
				this.balizaEdicion.BALIZA_PLANO.setX(this.balizaEdicion.ENTIDAD.X);
				this.balizaEdicion.BALIZA_PLANO.setY(this.balizaEdicion.ENTIDAD.Y);
			}
		}
		this.displayDialogBaliza = false;
		this.balizaEdicion = new BalizaFormulario();
		this.estadoEdicion = '';
	}

	onNotificationClicked($event){
		console.log('**** onNotificationClicked');
		this.router.navigate(['/mensajes/nuevo', { id: $event.id }]);
	}

	onNotificationMoved($event){
		console.log('**** onNotificationMoved');
	}


	public onContentClicked(event) {

		console.log('onContentClicked ' + event);
		console.log('event.id ' + event.id);
		if (this.permisos.Mapa_plano_contenido === 2  && this.permisos.Mapa_plano_contenido_formulario !== 0){
			const contenidoPlano = this.mapContents.get(event.id);
			// this.nodoEdicion = new NodoFormulario(nodoPlano);
			// this.zoomCenterCoords = [contenidoPlano.getX(), contenidoPlano.getY()];
			console.log('ESTADO EDICION: ' + this.estadoEdicion );
			// Si estamos seleccionando un nodo como destino de una conexion portal limitamos que no se pueda conectar un nodo consigomismo
			let mismoContenido  = false;
			if ( this.estadoEdicion === 'CONTENIDO_SELEC'){
				console.log('Ya estamos editando la posicion de un contenido');
				mismoContenido = (event.id === this.contenidoEdicion.Id);
				if(!mismoContenido){
					this.onFormularioContenidoCerrado(event)
				}
			}

			if ( this.estadoEdicion === ''){
				let formContenido = () => {
					this.estadoEdicion = 'CONTENIDO_SELEC';
					this.resaltarContenidoSeleccionado(event.id);
					console.log('contenidoPlano ' + contenidoPlano);
					const imagen = this.contenidosFormulario.find( x => x.ENTIDAD.Id === event.id).Imagen;
					console.log(imagen)
					this.contenidoEdicion = new Contenido().fromNodoPlano(contenidoPlano); // new Contenido(contenidoPlano); //  event.id;
					this.contenidoEdicion.Imagen = imagen;
					this.displayDialogContenido = true;
					this.msgs = [];
				}

				if (!mismoContenido) {
					setTimeout(() => {
						formContenido();
					}, 200);
				}
				else {
					formContenido();
				}
			}
			console.log('POST CONTENIDO_SELEC');
		}
	}
	public onContentMoved(event) {
		let seccionDetectada;
		let nodosSeccionDetectada;
		let distanciaMinima = Constantes.MAX_PESO;
		let nodoMasCercano;
		console.log('onContentMoved');
		console.log('---------------------------------');
		const contentPlano = this.mapContents.get(event.id);
		const click_X = this.contenidoEdicion.CONTENIDO_PLANO.getX();
		const click_Y = this.contenidoEdicion.CONTENIDO_PLANO.getY();
		console.log(this.contenidoEdicion.X + ' , ' + this.contenidoEdicion.Y);
		//  Calcular la nueva seccion...
		seccionDetectada = this.seccionDefecto;
		this.sections.forEach((seccionPlano: SeccionPlano) => {
			if (seccionPlano.getCoordenadasPoligono()) {
				if (this.pointInPolygon([click_X as number, click_Y as number], seccionPlano.getCoordenadasPoligono())) {
					seccionDetectada = seccionPlano.ENTIDAD;
				}
			}
		});
		nodosSeccionDetectada = seccionDetectada ? seccionDetectada.NODOS : [];
		if (!nodosSeccionDetectada || nodosSeccionDetectada.length === 0) {
			this.contenidoEdicion.CONTENIDO_PLANO.setX(this.contenidoEdicion.X);
			this.contenidoEdicion.CONTENIDO_PLANO.setY(this.contenidoEdicion.Y);
			return false;
		}
		this.contenidoEdicion.X = click_X;
		this.contenidoEdicion.Y = click_Y;
		// d = sqrt( (x2 - x1)^2 + (y2 - y1)^2 )
		nodosSeccionDetectada.forEach(nodo => {
			const x1 = nodo.X;
			const y1 = nodo.Y;
			const x2 = this.contenidoEdicion.X;
			const y2 = this.contenidoEdicion.Y;
			const d = Math.sqrt( Math.pow((x2 - x1), 2) + Math.pow((y2 - y1), 2) );
			console.log('--- Distancia a: ' + nodo.Nombre + ' = ' + d);
			if (d < distanciaMinima) {
				distanciaMinima = d;
				nodoMasCercano = nodo;
			}
		});
		console.log('Seccion Seleccionada:  ' + seccionDetectada.Nombre);
		console.log('Nodo mas Cercano:  ' + nodoMasCercano.Nombre);
	}
	public onContentGuardado(event) {
		const result = event.result;
		if (result === true) {
			this.displayDialogContenido = false;
			this.onFormularioContenidoCerrado(undefined);
			this.reasignarContenidos();
			this.appComponent.showSuccess(this.translate.instant('Mapas.contenidoguardadook'));
		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.contenidoguardadoerror'));
		}
	}
	onFormularioContenidoAbierto(event){
	}
	public onFormularioContenidoCerrado(event) {
		console.log('onFormularioContenidoCerrado');
		this.resaltarContenidoSeleccionado();
		if (this.displayDialogContenido === true) { //  Descartado
			if (this.contenidoEdicion.ENTIDAD) {
				this.contenidoEdicion.CONTENIDO_PLANO.setX(this.contenidoEdicion.ENTIDAD.X);
				this.contenidoEdicion.CONTENIDO_PLANO.setY(this.contenidoEdicion.ENTIDAD.Y);
				if (this.contenidoEdicion.ENTIDAD.TIPOLOGIA_NODO) {
					if ( this.contenidoEdicion.ENTIDAD.TIPOLOGIA_NODO.TIPOLOGIA_NODO) {
						this.contenidoEdicion.CONTENIDO_PLANO.setSimbolo(this.contenidoEdicion.ENTIDAD.TIPOLOGIA_NODO.IconoRepresentacion);
					}
					else{
						console.log('3.- NO TIPOLOGIA NODO');
					}
				}
			}
			console.log('TODO: Implementar desacer asignaciones Seccion y Nodo');
		}
		this.displayDialogContenido = false;
		this.contenidoEdicion = new Contenido();
		this.estadoEdicion = '';
	}


	public onNodoPortalCrearPressed($event){
		this.estadoEdicion = 'PORTAL_CREAR';
	}

	public onNodoPortalCancelPressed($event){
		this.estadoEdicion = 'NODO_SELEC';
	}

	onConexionPortalSeleccionada(item){
		const conexionFormulario: ConexionFormulario = new ConexionFormulario().fromENTIDAD(item);
		this.conexionEdicion = conexionFormulario;
		this.displayDialogEditarConexion = true;
		this.msgs = [];

		const conexiones_desde_nodo_destino = item.NodoDestino.CONEXIONS_NODOS_ORIGEN;
		const conexionAux = conexiones_desde_nodo_destino.filter(x => x.IdNodoDestino === item.NodoOrigen.Id)[0];
		this.conexionEdicionVuelta = new ConexionFormulario().fromENTIDAD(conexionAux);

		const auxOrigen = new NodoPlano(item.NodoOrigen.Id, item.NodoOrigen.Nombre, item.NodoOrigen.X, item.NodoOrigen.Y, '', null, 1);
		const auxDestino = new NodoPlano(item.NodoDestino.Id, item.NodoDestino.Nombre, item.NodoDestino.X, item.NodoDestino.Y, '', null, 1);

		this.conexionEdicion.NODO_PLANO_ORIGEN = auxOrigen;
		this.conexionEdicion.NODO_PLANO_DESTINO = auxDestino;

		this.conexionEdicion.Idiomas = this.idiomaService.getMapConexionNodoIdiomas(this.conexionEdicion.ENTIDAD.IDIOMAS);
		this.conexionEdicionVuelta.Idiomas = this.idiomaService.getMapConexionNodoIdiomas(this.conexionEdicionVuelta.ENTIDAD.IDIOMAS);
		const a = 1;
	}

	protected abrirMenuConexion(conexionPlano: ConexionPlano, mp: number[], g: any) {
		const link_entries = [
			{ icon : 'assets/planos/fa/raw-svg/solid/code-branch.svg', action: 'divide' }
		];
		const that = this;
		this.todosHide();

		mp[0] *= this.mapaZoom;
		mp[1] *= this.mapaZoom;
		const _zoom_click = this.mapaZoom;
		this.link_segment_menu = d3RadialMenu.d3RadialMenu()
			.scale(D3SCALEMENU).radius(D3RADIUSMENU).thickness(D3THICKNESSMENU).iconSize(D3ICONSIZEMENU)
			.entries(link_entries)
			.on('click', function(action, menu) {
				if (action === 'divide') {
					// console.log("divide " + menu.data().id);
					const _mp = [ mp[0] / _zoom_click , mp[1] / _zoom_click ];
					const coordenadas: number[][] = conexionPlano.getRuta();
					const indice = that.obtenerIndiceSegmento(_mp, coordenadas);
					console.log('indice = ' + indice);
					if (typeof(indice) !== 'undefined' && indice != null && indice >= 0) {
						coordenadas.splice(indice + 1, 0, _mp);
						that.conexionEdicion.CONEXION_PLANO.setRuta(conexionPlano.getRuta());

						that.asignarLinks(that.links);
					}
				}
			})
			.showMenu(g, mp, conexionPlano);
	}
	public onLinkClicked(event) {
		console.log('onLinkClicked ' + event);
		console.log('event.id ' + event.id);
		this.mpClick = [event.mp[0] , event.mp[1]];
		if (this.permisos.Mapa_plano_conexion !== 0  && this.permisos.Mapa_plano_conexion_formulario !== 0){
			if ((this.estadoEdicion === 'TRAMO_SELEC' || this.estadoEdicion === '') && (this.conexionEdicion === undefined || !this.conexionEdicion.Id)) {
				this.estadoEdicion = 'TRAMO_SELEC';
				this.resaltarConexionSeleccionada(event.id);
				const conexionPlano = this.mapLinks.get(event.id);
				const conexionFormulario: ConexionFormulario = new ConexionFormulario().fromConexionPlano(
					conexionPlano,
					this.mapNodes.get(conexionPlano.getIdNodoOrigen()),
					this.mapNodes.get(conexionPlano.getIdNodoDestino())
				);
				conexionFormulario.CONEXION_PLANO.setMostrarConectores(true);
				this.conexionEdicion = conexionFormulario;
				this.displayDialogEditarConexion = true;
				this.msgs = [];
				const nodo_destino = this.mapNodes.get(conexionPlano.getIdNodoDestino());
				const nodo_origen = this.mapNodes.get(conexionPlano.getIdNodoOrigen());

				const conexiones_desde_nodo_destino = nodo_destino.ENTIDAD.CONEXIONS_NODOS_ORIGEN;
				const conexionAux1 = conexiones_desde_nodo_destino.filter(x => x.IdNodoDestino === nodo_origen.getId());
					console.log(conexionPlano)
					console.log(conexionAux1)
				let conexionvueltaId: String = '';
				conexionAux1.forEach(element => {
					
					let conexion = this.mapLinks.get(element.Id);

					let arrayRutas = [];
					let arrayRutasIda = conexionPlano.getRuta();
					let arrayRutasInvertidas = [...arrayRutasIda].reverse();

					if(conexion.getRuta() === null){
						let array = [];
						conexion.setRuta(array);
					}

					if(conexion.getIdNodoOrigen() === conexionPlano.getIdNodoDestino() && conexion.getIdNodoDestino() === conexionPlano.getIdNodoOrigen() && conexion.getRuta().length === 0){

						conexion.setRuta(arrayRutasInvertidas);
						arrayRutas = conexion.getRuta();
					}else{

						arrayRutas = conexion.getRuta();
					}

					arrayRutasInvertidas = [...arrayRutas].reverse();
					
					let isEqual = JSON.stringify(arrayRutasInvertidas) === JSON.stringify(arrayRutasIda);
					console.log(isEqual);
					 if(isEqual){
					  conexionvueltaId = conexion.getId();
					   }
				});
				
				//const conexionAux = conexiones_desde_nodo_destino.filter(x => x.IdNodoDestino === nodo_origen.getId())[0];
				const conexionVueltaPlano = this.mapLinks.get(conexionvueltaId);
				console.log(conexionVueltaPlano)
				this.conexionEdicionVuelta = new ConexionFormulario().fromConexionPlano(
					conexionVueltaPlano,
					conexionVueltaPlano.nodoOrigen,
					conexionVueltaPlano.nodoDestino
				);
				this.conexionEdicion.Idiomas = this.idiomaService.getMapConexionNodoIdiomas(this.conexionEdicion.ENTIDAD.IDIOMAS);
				this.conexionEdicionVuelta.Idiomas = this.idiomaService.getMapConexionNodoIdiomas(this.conexionEdicionVuelta.ENTIDAD.IDIOMAS);
				const a = 1;
			}
			else if (this.estadoEdicion === 'TRAMO_SELEC' && this.conexionEdicion !== undefined) {
				// Solo dejamos agregar puntos si pincho sobre la conexion que esta seleccionada.
				if (event.id === this.conexionEdicion.Id) {
					const conexionPlano = this.mapLinks.get(event.id);
					this.abrirMenuConexion(conexionPlano, event.mp, event.g_noZoom);
				}
			}
		}
	}
	cargarPlano() {
		this.zoomLevels = [this.alaSeleccionada.zoomMinimo, this.alaSeleccionada.zoomMaximo];
		this.currentZoomLevel = 1;

		this.pathSvgPlano = this.alaSeleccionada.RutaImagen;
		this.pathPlano = this.alaSeleccionada.RutaImagen;

		this.compass = new Compass(100, 100, 0);
		console.log('this.alaSeleccionada.RutaImagen = ' + this.alaSeleccionada.RutaImagen);
	}
	// CallBacks Formulario nodo
	onFormularioNodoAbierto($event){
		console.log('onFormularioNodoAbierto: No hace NADA');
	}
	public onFormularioNodoCerrado(event) {
		console.log('onFormularioNodoCerrado');
		this.resaltarNodoSeleccionado();
		if (this.displayDialogEditarNodo === true) { //  Descartado
			if (this.nodoEdicion.ENTIDAD) {
				this.nodoEdicion.NODO_PLANO.setX(this.nodoEdicion.ENTIDAD.X);
				this.nodoEdicion.NODO_PLANO.setY(this.nodoEdicion.ENTIDAD.Y);
				if (this.mapNodes) {
					this.mapNodes.set(this.nodoEdicion.Id, this.nodoEdicion.NODO_PLANO);
				}
				if (this.nodoEdicion.ENTIDAD.TIPOLOGIA_NODO) {
					if (this.nodoEdicion.ENTIDAD.TIPOLOGIA_NODO) {
						this.nodoEdicion.NODO_PLANO.setSimbolo(this.nodoEdicion.ENTIDAD.TIPOLOGIA_NODO.IconoRepresentacion);
					}
					else{
						console.log('4.- NO TIPOLOGIA NODO');
					}
				}
			}
			this.nodoEdicion.NODO_PLANO.conexiones.forEach(conexion => {
				const ruta: number[][] = this.nodoEdicion.NODO_PLANO.rutasconexiones_backup.get(conexion.getId());
				conexion.setRuta(ruta);
			});

			this.asignarNodes(this.nodes);
			this.asignarLinks(this.links);
		}

		this.balizasResaltar = [];
		this.desmarcarBalizas();

		this.displayDialogEditarNodo = false;
		this.nodoEdicion = new NodoFormulario();
		this.estadoEdicion = '';
		this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
	}
	public onNodoGuardado(event) {
		const result = event.result;
		const nodoFormulario: NodoFormulario = event.element;
		if (result === true) {
			if (this.mapNodes) {
				this.mapNodes.set(nodoFormulario.Id, nodoFormulario.NODO_PLANO);
			}
			this.displayDialogEditarNodo = false;
			this.onFormularioNodoCerrado(undefined);
			this.reasignarContenidos();
			this.appComponent.showSuccess(this.translate.instant('Mapas.nodoguardadook'));
		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.nodoguardadoerror'));
		}
	}
	public onNodoEliminado(event) {
		const result = event.result;
		const nodoFormulario: NodoFormulario = event.element;
		if (result === true) {
			if (this.mapNodes && this.mapNodes.has(nodoFormulario.Id)) {
				// Lo añado si no estaba para que el componente plano detecte cambios en los nodos
				this.mapNodes.set(nodoFormulario.Id, nodoFormulario.NODO_PLANO);
				this.mapNodes.get(nodoFormulario.Id).setEliminado(true);
				this.mapNodes.delete(nodoFormulario.Id);
			}
			this.displayDialogEditarNodo = false;
			this.onFormularioNodoCerrado(undefined);
			this.appComponent.showSuccess(this.translate.instant('Mapas.nodoeliminadook'));
		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.nodoeliminadoerror'));
		}
	}
	public onNodoValidation(event) {
	}

	public onBalizaValidation(event) {
	}
	// CallBacks Formulario conexion
	public onFormularioConexionCerrado(event) {
		console.log('onFormularioConexionCerrado');
		this.resaltarConexionSeleccionada();
		if (this.conexionEdicion && this.conexionEdicion.CONEXION_PLANO) {
			this.conexionEdicion.CONEXION_PLANO.setMostrarConectores(false);
		}
		if (this.displayDialogEditarConexion === true) { //  Descartado
			if (this.conexionEdicion.CONEXION_PLANO.ENTIDAD) {
				this.conexionEdicion.CONEXION_PLANO.setRuta(JSON.parse(this.conexionEdicion.CONEXION_PLANO.ENTIDAD.CoordenadasCamino));
			}
			this.asignarLinks(this.links);
		}
		this.displayDialogEditarConexion = false;
		this.conexionEdicion = new ConexionFormulario();
		this.conexionEdicionVuelta = new ConexionFormulario();
		this.asignarLinks(this.links);
		if (!this.displayDialogEditarNodo) {
			this.nodoEdicion = new NodoFormulario();
			this.estadoEdicion = '';
		}

	}
	public onConexionGuardada(event) {
		const result = event.result;
		const conexionFormulario: ConexionFormulario = event.element[0];
		const conexionFormularioVuelta: ConexionFormulario = event.element[1];
		if (result === true) {
			if (this.mapLinks) {
				this.mapLinks.set(conexionFormulario.Id, conexionFormulario.CONEXION_PLANO);
				this.mapLinks.set(conexionFormularioVuelta.Id, conexionFormularioVuelta.CONEXION_PLANO);
			}
			this.displayDialogEditarConexion = false;
			this.onFormularioContenidoCerrado(undefined); //  Se llama a onFormularioNodoCerrado
			this.reasignarContenidos();
			this.appComponent.showSuccess(this.translate.instant('Mapas.conexionguardadaok'));
		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.conexionguardadaerror'));
		}
	}
	public onConexionEliminada(event) {
		console.log(event)
		const result = event.result;
		//console.log(result)

		 const conexionFormulario: ConexionFormulario = event.element[0];
		 const conexionFormularioVuelta: ConexionFormulario = event.element[1];
		 if (result === true) {
			if (this.mapLinks && this.mapLinks.has(conexionFormulario.Id)) {
				this.mapLinks.get(conexionFormulario.Id).setEliminado(true);
				this.mapLinks.delete(conexionFormulario.Id);
			}
			if (this.mapLinks && this.mapLinks.has(conexionFormularioVuelta.Id)) {
				this.mapLinks.get(conexionFormularioVuelta.Id).setEliminado(true);
				this.mapLinks.delete(conexionFormularioVuelta.Id);
			}

		 	// Eliminarlas del Nodo y refrescar el nodoFormulario que se esta editando
		 	if (this.displayDialogEditarNodo) {
				console.log('aqui')
		 		if (this.nodoEdicion) {
		 			const nodoAux = this.mapNodes.get(this.nodoEdicion.Id);
		 			nodoAux.conexiones = nodoAux.conexiones.filter( c => c.getId() !== conexionFormulario.Id  &&  c.getId() !== conexionFormularioVuelta.Id);
		 			this.nodoEdicion = new NodoFormulario().fromNodoPlano(nodoAux);
		 		}
		 	}

		 	this.displayDialogEditarConexion = false;
		 	this.onFormularioConexionCerrado(undefined); //  Se llama a onFormularioNodoCerrado
		 	this.spinner.style.display = 'none';
		 	this.appComponent.showSuccess(this.translate.instant('Mapas.conexioneliminadaok'));
		 }
		 else {
		 	this.spinner.style.display = 'none';
		 	this.appComponent.showError(this.translate.instant('Mapas.conexioneliminadaerror'));
		 }
	}
	public onConexionValidation(event) {
	}
	// CallBacks Formulario SECCION
	public onFormularioSeccionCerrado(event) {
		console.log('onFormularioSeccionCerrado');
		this.resaltarSeccionSeleccionado();
		if (this.seccionEdicion && this.seccionEdicion.SECCION_PLANO) {
			this.seccionEdicion.SECCION_PLANO.setMostrarConectores(false);
		}
		if (this.displayDialogEditarSeccion === true) { //  Descartado
			if (this.seccionEdicion.SECCION_PLANO.ENTIDAD) {
				this.seccionEdicion.SECCION_PLANO.setCoordenadasPoligono(JSON.parse(this.seccionEdicion.SECCION_PLANO.ENTIDAD.CoordenadasPoligono));
			}
		}
		this.asignarSections(this.sections);
		this.displayDialogEditarSeccion = false;
		/*if(this.seccionEdicion.FechaBaja !== null){
			this.apareceBoton = true;
		}*/
		this.seccionEdicion = new SeccionFormulario();
		this.estadoEdicion = '';
		this.colorSeleccionado = '#00000';
		this.limpiarSeccionesFantasma();
	}
	public onSeccionGuardada(event) {
		console.log(event)
		const result = event.result;
		const seccionFormulario: SeccionFormulario = event.element;

		this.reasignarNodosSeccion(seccionFormulario);
		if (result === true) {
			if (this.mapSections) {
				this.mapSections.delete(seccionFormulario.Id);
				this.mapSections.set(seccionFormulario.Id, seccionFormulario.SECCION_PLANO);
			}
			this.displayDialogEditarSeccion = false; //  Se llamara a onFormularioNodoCerrado
			/*this.apareceBoton = false;*/
			this.reasignarContenidos();
			this.appComponent.showSuccess(this.translate.instant('Mapas.seccionguardadaok'));
		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.seccionguardadaerror'));
		}
		this.limpiarSeccionesFantasma();
	}
	public onSeccionEliminada(event) {
		const result = event.result;
		const seccionFormulario: SeccionFormulario = event.element;
		if (result === true) {
			if (this.mapSections && this.mapSections.has(seccionFormulario.Id)) {
				this.mapSections.get(seccionFormulario.Id).setEliminado(true);
				this.mapSections.delete(seccionFormulario.Id);
				const seccionPlano = this.sections.find(x => x.getId() === seccionFormulario.Id);
				const index = this.sections.indexOf(seccionPlano);
				this.sections.splice(index, 1);
			}
			this.displayDialogEditarSeccion = false; //  Se llamara a onFormularioNodoCerrado
			// this.apareceBoton = false;
			this.appComponent.showSuccess(this.translate.instant('Mapas.seccioneliminadaok'));
		}
		else {
			this.appComponent.showError(this.translate.instant('Mapas.seccioneliminadaerror'));
		}
		this.spinner.style.display = 'none';
		this.limpiarSeccionesFantasma();
	}
	public onSeccionValidation(event) {
	}
	private salvarElementosNoEdicionEstados(){
		const _elems = ['mostrarNodos', 'mostrarContenidos', 'mostrarSecciones', 'mostrarTramos'];
		this.elementosOcultadosNoEdicionOrigen = {};
		for (const _i in _elems){
			const _elem = _elems[_i];
			this.elementosOcultadosNoEdicionOrigen[_elem] = this[_elem];
		}
	}
	ocultarElementosEnNoEdicion(_excludes){
		this.salvarElementosNoEdicionEstados();

		for (const _elem in this.elementosOcultadosNoEdicionOrigen){
			if (_excludes.indexOf(_elem) >= 0){
				continue;
			}
			this[_elem] = false;
		}
	}
	desOcultarElementosEnNoEdicion(){
		for (const _elem in this.elementosOcultadosNoEdicionOrigen){
			this[_elem] = this.elementosOcultadosNoEdicionOrigen[_elem];
		}
	}
	/**/
	menucommand(comando) {
		// this.notificationsService.notify('info', 'some component', 'SELECCIONADO');
		// this.notificationsService.notify('info', 'Mapa', JSON.stringify(comando));
		this.estadoEdicion = comando.item.id;
		this.subEstadoEdicion = 'INICIAL';
		this.tramoNodoOrigen = null;
		this.tramoNodoDestino = null;
		if (comando.item.id === 'SECCION_SELEC') {
			this.ocultarElementosEnNoEdicion(['mostrarSecciones']);
			this.appComponent.showInfo(this.translate.instant('Mapas.elijaseccion'));
		}
		else if (comando.item.id === 'SECCION_CREAR') {
			this.ocultarElementosEnNoEdicion(['mostrarSecciones']);
			this.appComponent.showInfo(this.translate.instant('Mapas.dibujeseccion'));
		}
		else if (comando.item.id === 'NODO_SELEC') {
			this.appComponent.showInfo(this.translate.instant('Mapas.elijanodoeditar'));
			this.movible = true;
			console.log('this.movible = ' + this.movible);
		}
		else if (comando.item.id === 'NODO_CREAR') {
			this.appComponent.showInfo(this.translate.instant('Mapas.colocarnodo'));
			// this.notificationsService.notify('info', 'Nuevo Nodo', 'Haga click en el plano en la ubicación donde colocar el nuevo nodo');
		}
		else if (comando.item.id === 'TRAMO_SELEC') {
			this.appComponent.showInfo(this.translate.instant('Mapas.seleccionetramoeditar'));
		}
		else if (comando.item.id === 'TRAMO_CREAR') {
			this.appComponent.showInfo(this.translate.instant('Mapas.seleccioneprimernodoconectar'));
		}
		else if (comando.item.id === 'BALIZA_SELEC') {
			this.appComponent.showInfo(this.translate.instant('Mapas.seleccionebalizaeditar'));
		}
		else if (comando.item.id === 'BALIZA_CREAR') {
			//  TODO: SI NO HAY CONTENIDOS AVISAR
			if (this.mapNodes.size === 0) {
				this.appComponent.showAlert('warn', this.translate.instant('Mapas.imposibleColocarbaliza'));
				this.estadoEdicion = '';
			}
			else {
				this.appComponent.showInfo(this.translate.instant('Mapas.colocarbaliza'));
			}
		}
	}
	estanTodosEliminados(array){
		array.forEach(element => {
			if (!element.eliminado) {
				return false;
			}
		});
		return true;
	}
	descartarNodo() {
		this.nodoEdicion = new NodoFormulario();
		this.estadoEdicion = '';
	}
	guardarNodo() {
		const that = this;
		this.crearNodo()
			.then(function (oNODO) {
				that.displayDialogNuevoNodo = false;
				console.log('guardarNodo RESOLVED');
				// 	if (oNODO == null) {
				/*
					if (oNODO != null) {
						that.appComponent.showError('Error al guardar el nodo');
						that.notificationsService.notify('error', 'Edición de nodo', 'Error al guardar el nodo');
					}
					else {
				*/
				const icono = 'wifi.png';
				// that.plano.odo(that.mpClick[0], that.mpClick[1], 'assets/planos/iconos/' + icono);
				// that.notificationsService.notify('info', 'Edición de nodo', 'Nodo creado');
				that.appComponent.showSuccess(this.translate.instant('Mapas.nodocreado'));
				that.estadoEdicion = '';
				/*
					}
				*/
			});
	}
	crearNodo(): Promise<any> {
		return new Promise(resolve => {
			const that = this;
			return this.entityManagerProvider.newNodo()
				.then(function (oNODO) {
					resolve(oNODO);
				})
				.catch(function (e) {
					this.displayDialogNuevoNodo = false;
					resolve(null);
				});
		});
	}
	crearConexionNodo(nodoPlano, esPortal = false){
		const that = this;
		const pesosConexionIda = [];
		const pesosConexionVuelta = [];
		let promises: any[] = [];
		const idEspacio = this.authService.getIdEspacio();

		this.spinner.style.display = 'inherit';
		//  const nodoPlano = this.mapNodes.get(event.id);
		this.tramoNodoDestino = nodoPlano;
		if ((this.tramoNodoDestino.ENTIDAD.Id === this.tramoNodoOrigen.ENTIDAD.Id)) {
			this.appComponent.showError(this.translate.instant('Mapas.nodoOrigenDestinoIguales'));
			this.spinner.style.display = 'none';
		}
		else{
			for (let index = 0; index < that.perfilesMovilidad.length; index++) {
				promises.push(this.entityManagerProvider.newPESO_CONEXION());
			}

			return allSettled(promises)
			.then(function(pesosIda){
				for (let index = 0; index < pesosIda.length; index++) {
					const element = pesosIda[index].result;
					element.Peso = Constantes.PESO;
					element.PerfilMovilidad = that.perfilesMovilidad[index];
					pesosConexionIda.push(element);
				}
				promises = [];

				for (let index = 0; index < that.perfilesMovilidad.length; index++) {
					promises.push(that.entityManagerProvider.newPESO_CONEXION());
				}
				return allSettled(promises);
			})
			.then(function(pesosVuelta){
				for (let index = 0; index < pesosVuelta.length; index++) {
					const element = pesosVuelta[index].result;
					element.Peso = Constantes.PESO;
					element.PerfilMovilidad = that.perfilesMovilidad[index];
					pesosConexionVuelta.push(element);
				}

				return that.entityManagerProvider.newCONEXION_NODOS();
			})
			.then(function(oConexionNodos) {
				oConexionNodos.IdEntidad = that.authService.getIdEntidad();
				// Indicaciones por idioma Conexion de Ida
				oConexionNodos.IDIOMAS.forEach(CONEXION_NODOS_IDIOMA => {
					CONEXION_NODOS_IDIOMA.Indicacion = that.translate.instant('Mapas.sinindicaciones');
					if (CONEXION_NODOS_IDIOMA.IDIOMA.Default) {
						oConexionNodos.Indicacion = CONEXION_NODOS_IDIOMA.Indicacion ? CONEXION_NODOS_IDIOMA.Indicacion : '';
					}
				});
				if (esPortal) {
					oConexionNodos.CoordenadasCamino = '[]';
				}
				else{
					oConexionNodos.CoordenadasCamino = JSON.stringify([ [that.tramoNodoOrigen.getX(), that.tramoNodoOrigen.getY()], [that.tramoNodoDestino.getX(), that.tramoNodoDestino.getY()] ]);
				}

				oConexionNodos.IdNodoOrigen = that.tramoNodoOrigen.getId();
				oConexionNodos.IdNodoDestino = that.tramoNodoDestino.getId();
				oConexionNodos.CortadoTemporalmente = false;
				pesosConexionIda.forEach(elemento => {
					oConexionNodos.PESO_CONEXIONS.push(elemento);
				});
				return true;
			})
			.then(function(b) {
				return that.entityManagerProvider.newCONEXION_NODOS();
			})
			.then(function(oConexionNodos) {
				oConexionNodos.IdEntidad = that.authService.getIdEntidad();
				// Indicaciones por idioma Conexion de Vuelta
				oConexionNodos.IDIOMAS.forEach(CONEXION_NODOS_IDIOMA => {
					CONEXION_NODOS_IDIOMA.Indicacion = that.translate.instant('Mapas.sinindicaciones');
					if (CONEXION_NODOS_IDIOMA.IDIOMA.Default) {
						oConexionNodos.Indicacion = CONEXION_NODOS_IDIOMA.Indicacion ? CONEXION_NODOS_IDIOMA.Indicacion : '';
					}
				});
				//oConexionNodos.CoordenadasCamino = null;
				if (esPortal) {
					oConexionNodos.CoordenadasCamino = '[]';
				}
				else{
					oConexionNodos.CoordenadasCamino = JSON.stringify([[that.tramoNodoDestino.getX(), that.tramoNodoDestino.getY()], [that.tramoNodoOrigen.getX(), that.tramoNodoOrigen.getY()]]);
				}
				//  A la conexion de vuelta no le asignamos ruta grafica
				oConexionNodos.IdNodoOrigen = that.tramoNodoDestino.getId();
				oConexionNodos.IdNodoDestino = that.tramoNodoOrigen.getId();
				oConexionNodos.CortadoTemporalmente = false;
				pesosConexionVuelta.forEach(elemento => {
					oConexionNodos.PESO_CONEXIONS.push(elemento);
				});
				return that.entityManagerProvider.saveChanges();
			})
			.then(function(msg) {

				const aux_1 = msg.entities.filter(x => x.constructor.name.split('__UBIMAPS', 2)[0] === 'CONEXION_NODOS')[0]; // msg.entities[msg.entities.length - 1];
				const aux_2 = msg.entities.filter(x => x.constructor.name.split('__UBIMAPS', 2)[0] === 'CONEXION_NODOS')[1]; //
				console.log(aux_1)
				console.log(aux_2)
				// Conexion Ida
				const conexion_ida = aux_1;
				console.log(conexion_ida)
				const coordenadasCamino: Array<Array<number>> = (!conexion_ida.CoordenadasCamino ? null : JSON.parse(conexion_ida.CoordenadasCamino));
				const conexionPlano = new ConexionPlano(conexion_ida.Id, coordenadasCamino, conexion_ida.IdNodoOrigen, conexion_ida.IdNodoDestino, conexion_ida.NodoOrigen.SECCION.ALA.PuntosConexionScale, conexion_ida.NodoOrigen.SECCION.ALA.ConexionScale);
				conexionPlano.ENTIDAD = conexion_ida;
				// Conexion Vuelta
				const conexion_vuelta = aux_2;
				console.log(conexion_vuelta)
				const coordenadasCaminoVuelta: Array<Array<number>> = (!conexion_vuelta.CoordenadasCamino ? null : JSON.parse(conexion_vuelta.CoordenadasCamino));
				const conexionPlanoVuelta = new ConexionPlano(conexion_vuelta.Id, coordenadasCaminoVuelta, conexion_vuelta.IdNodoOrigen, conexion_vuelta.IdNodoDestino, conexion_vuelta.NodoOrigen.SECCION.ALA.PuntosConexionScale, conexion_vuelta.NodoOrigen.SECCION.ALA.ConexionScale);
				conexionPlanoVuelta.ENTIDAD = conexion_vuelta;

				// Pintar nueva conexion en plano
				that.links.push(conexionPlano);
				//that.links.push(conexionPlanoVuelta);
				that.asignarLinks(that.links);
				that.mapLinks.set(conexion_ida.Id, conexionPlano);

				// Preparar Formulario Para Edicion

				that.estadoEdicion = 'TRAMO_SELEC';
				that.displayDialogEditarConexion = true;
				that.msgs = [];

				let nodo_destino;
				let nodo_origen;
				if (esPortal) {
					nodo_destino = that.tramoNodoDestino;
					nodo_origen = that.tramoNodoOrigen;
				}
				else{
					nodo_destino = that.mapNodes.get(conexionPlano.getIdNodoDestino());
					nodo_origen = that.mapNodes.get(conexionPlano.getIdNodoOrigen());
				}

				that.conexionEdicion = new ConexionFormulario().fromConexionPlano(
					conexionPlano,
					nodo_origen,
					nodo_destino
				);
				that.conexionEdicionVuelta = new ConexionFormulario().fromConexionPlano(
					conexionPlanoVuelta,
					conexionPlanoVuelta.nodoOrigen,
					conexionPlanoVuelta.nodoDestino
				);

				nodo_origen.conexiones.push(conexionPlano);
				nodo_origen.conexiones.push(conexionPlanoVuelta);
				nodo_destino.conexiones.push(conexionPlano);
				nodo_destino.conexiones.push(conexionPlanoVuelta);
				that.mapNodes.set(nodo_origen.getId(), nodo_origen);
				that.mapNodes.set(nodo_destino.getId(), nodo_destino);
				that.conexionEdicion.CONEXION_PLANO.setMostrarConectores(true);
				that.resaltarConexionSeleccionada(that.conexionEdicion.Id);

				that.nodoEdicion = new NodoFormulario().fromNodoPlano(nodo_origen);

				// Ocultar Spinner
				that.spinner.style.display = 'none';

				that.tramoNodoOrigen = null;
				that.tramoNodoDestino = null;
				// that.estadoEdicion = '';
				that.appComponent.showSuccess(that.translate.instant('Mapas.nuevaconexionok'));
				return msg;
			})
			.catch(function(e) {
				that.spinner.style.display = 'none';
				that.tramoNodoOrigen = null;
				that.tramoNodoDestino = null;
				that.estadoEdicion = '';
				that.appComponent.showError(that.translate.instant('Mapas.nuevaconexionerror') + e.toString());
				console.log('Exception: ' + e.toString());
				return false;
			});
		}
	}

	setTransparenciaCapa(transparencias: { secciones: number, nodos: number, conexiones: number, contenidos: number, Balizas: number, Notificaciones: number}){
		// { secciones: 1, nodos: 1, conexiones: 1, contenidos: 1, Balizas: 1}

		this.sectionsOpacity = transparencias.secciones;
		this.nodesOpacity = transparencias.nodos;
		this.linksOpacity = transparencias.conexiones;
		this.contentsOpacity = transparencias.contenidos;
		this.beaconsOpacity = transparencias.Balizas;
		this.notificationsOpacity = transparencias.Notificaciones;

		// TODO: Quitar cuando meta el Opacidad de beacons en el componente plano
		// this.mostrarBalizas = this.beaconsOpacity === 1 ? true : false;

	}

	ready(error, plano, compass, svg) {
		/*
		svg.on('click', function(d) {
		  const mp_click = D3.mouse(plano.g.node());
		  const scale = plano.zoom._scale;
		  console.log('CLICK PIXELS = ' + mp_click);
		  console.log('CLICK LL = ' + plano.projection.invert(mp_click));
		});
		*/
		// // // // // // // /
		plano.recalcular_referencia();
		plano.crear_proyeccion();
		compass.create(svg);
		compass.rotate(-plano.rotation);
		plano.habilitar_zoom([0.1, 30], function (ev) {
			compass.rotate(plano.manual_rotation + -plano.rotation);
		});
		//  mthat.plano.habilitar_rotacion();
		// // // // // // // //
		let pp = 0;
		const gc = plano.g.append('g');
		gc.selectAll('.puntos')
			.data(plano.referencia.geojson.features)
			.enter()
			.append('path')
			.attr('class', function (d) { return 'puntos ' + 'manz-' + d.id; })
			.attr('d', plano.path)
			.style('fill', function (d) { pp++; return pp === 1 ? 'red' : 'red'; });
		// // // // // /
		this.alaSeleccionada.SECCIONS.array.forEach(seccion => {
			seccion.NODOS.array.forEach(nodo => {
				const icono = 'wifi.png';
				// this.plano.odo(nodo.X, nodo.Y, 'assets/planos/iconos/' + icono);
				// plano.append_circle(gc, nodo.X, nodo.Y, 'orange');
			});
		});
		/*
		plano.append_circle_ll(gc, -6.278026914722838, 36.509577494026765, 'orange');
		plano.append_circle_ll(gc, -6.2779188, 36.5097578, 'green');
		plano.append_circle_ll(gc, -6.2779670, 36.5084507, 'green');
		plano.append_circle_ll(gc, -6.2776212, 36.5082182, 'green');
		plano.append_circle_ll(gc, -6.2785418, 36.5095343, 'green');
		plano.append_circle_ll(gc, -6.2771698, 36.5086732, 'green');
		plano.append_circle_ll(gc, -6.278466, 36.509346, 'green');
		plano.append_circle_ll(gc, -6.277311, 36.508348, 'green');
		*/
		console.log('PROJECTED = ' + plano.projection([-6.278026914722838, 36.509577494026765]));
		plano.append_circle_ll(gc, plano.referencia.p_0.longitud, plano.referencia.p_0.latitud + 0.0001, 'blue');
		plano.append_circle_ll(gc, plano.referencia.p_0.longitud, plano.referencia.p_0.latitud + 0.0002, 'blue');
		plano.autoajustar_zoom();
		return;
	}
	resaltarConexionSeleccionada(id?){
		this.opacidad = 1;
		if (id){
			this.opacidad = 0.2;
			// Desmarcamos todas las conexiones
			this.mapLinks.forEach((value: ConexionPlano, key: string) => {
				if (value.ENTIDAD && value.ENTIDAD.CortadoTemporalmente){
					// value.fill  = Constantes.conexionFill_CORTADO;
					value.stroke = Constantes.conexionStroke_CORTADO;
					value.strokeWidth = Constantes.conexionStrokeWidth_CORTADO;
					value.lineHoverStroke = Constantes.conexionsymbolHoverStroke_CORTADO;
				}
				else{
					// value.fill  = Constantes.conexionFill;
					value.stroke = Constantes.conexionStroke;
					value.strokeWidth = Constantes.conexionStrokeWidth;
					value.lineHoverStroke = Constantes.conexionsymbolHoverStroke;
				}
				this.mapLinks.set(key, value);
			});
			// Marcamos la nueva Conexion seleccionada
			const conexionP = this.mapLinks.get(id);
			// conexionP.fill  = Constantes.conexionFill_SELECT;
			conexionP.stroke  = Constantes.conexionStroke_SELECT;
			conexionP.strokeWidth  = Constantes.conexionStrokeWidth_SELECT;
			conexionP.lineHoverStroke = Constantes.conexionsymbolHoverStroke_SELECT;
			this.mapLinks.set(id, conexionP);
		}
		else {
			// Desmarcamos todas las conexiones
			this.mapLinks.forEach((value: ConexionPlano, key: string) => {
				if (value.ENTIDAD && value.ENTIDAD.CortadoTemporalmente){
					// value.fill  = Constantes.conexionFill_CORTADO;
					value.stroke = Constantes.conexionStroke_CORTADO;
					value.strokeWidth = Constantes.conexionStrokeWidth_CORTADO;
					value.lineHoverStroke = Constantes.conexionsymbolHoverStroke_CORTADO;
				}
				else{
					// value.fill  = Constantes.conexionFill;
					value.stroke = Constantes.conexionStroke;
					value.strokeWidth = Constantes.conexionStrokeWidth;
					value.lineHoverStroke = Constantes.conexionsymbolHoverStroke;
				}
				this.mapLinks.set(key, value);
			});
		}

		this.setTransparenciaCapa({ secciones: this.opacidad, nodos: this.opacidad, conexiones: 1, contenidos: this.opacidad, Balizas: this.opacidad, Notificaciones: this.opacidad});
	}
	resaltarNodoSeleccionado(id?){
		this.opacidad = 1;
		if (id){
			this.opacidad = 0.2;
			// Desmarcamos todos los Nodos
			this.mapNodes.forEach((value: NodoPlano, key: string) => {
				value.symbolStroke =  Constantes.nodoSymbolStroke;
				value.symbolFill =   Constantes.nodoSymbolFill;
				value.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth;
				value.sectionHoverFill =   Constantes.nodoSectionHoverFill;
				value.sectionHoverStroke =   Constantes.nodoSectionHoverStroke;
				value.symbolHoverFill = Constantes.nodosymbolHoverFill;
				value.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
				value.symbolSize =   Constantes.nodoSymbolSize;
				value.setIconHeight(Constantes.nodoIconHeight);
				value.setIconWidth(Constantes.nodoIconWidth);
				this.mapNodes.set(key, value);
			});
			// Marcamos el nuevo Nodo seleccionada
			const nodoPlano = this.mapNodes.get(id);
			nodoPlano.symbolStroke =  Constantes.nodoSymbolStroke_SELECT;
			nodoPlano.symbolFill =   Constantes.nodoSymbolFill_SELECT;
			nodoPlano.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth_SELECT;
			nodoPlano.sectionHoverFill =   Constantes.nodoSectionHoverFill_SELECT;
			nodoPlano.sectionHoverStroke =   Constantes.nodoSectionHoverStroke_SELECT;
			nodoPlano.symbolHoverFill = Constantes.nodosymbolHoverFill;
			nodoPlano.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
			nodoPlano.symbolSize =   Constantes.nodoSymbolSize_SELECT;
			nodoPlano.setIconHeight(Constantes.nodoIconHeight_SELECT);
			nodoPlano.setIconWidth(Constantes.nodoIconWidth_SELECT);
			this.mapNodes.set(id, nodoPlano);
		}
		else {
			// Desmarcamos todos los Nodos
			this.mapNodes.forEach((value: NodoPlano, key: string) => {
				value.symbolStroke =  Constantes.nodoSymbolStroke;
				value.symbolFill =   Constantes.nodoSymbolFill;
				value.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth;
				value.sectionHoverFill =   Constantes.nodoSectionHoverFill;
				value.sectionHoverStroke =   Constantes.nodoSectionHoverStroke;
				value.symbolHoverFill = Constantes.nodosymbolHoverFill;
				value.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
				value.symbolSize =   Constantes.nodoSymbolSize;
				value.setIconHeight(Constantes.nodoIconHeight);
				value.setIconWidth(Constantes.nodoIconWidth);
				this.mapNodes.set(key, value);
			});
		}

		this.setTransparenciaCapa({ secciones: this.opacidad, nodos: 1, conexiones: this.opacidad, contenidos: this.opacidad, Balizas: 1, Notificaciones: this.opacidad});
	}
	desmarcarBalizas(){
		console.log('Desmarcamos todas las Balizas');
		const auxArray = [];
		this.mapBeacons.forEach((value: BeaconPlano, key: string) => {
			value.symbolStroke =  Constantes.nodoSymbolStroke;
			value.symbolFill =   Constantes.nodoSymbolFill;
			value.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth;
			value.sectionHoverFill =   Constantes.nodoSectionHoverFill;
			value.sectionHoverStroke =   Constantes.nodoSectionHoverStroke;
			value.symbolHoverFill = Constantes.nodosymbolHoverFill;
			value.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
			value.symbolSize =   Constantes.nodoSymbolSize;
			value.setIconHeight(Constantes.nodoIconHeight);
			value.setIconWidth(Constantes.nodoIconWidth);
			this.mapBeacons.set(key, value);
			auxArray.push(value);
		});

		this.asignarBeacons(auxArray);
		this.setTransparenciaCapa({ secciones: 1, nodos: 1, conexiones: 1, contenidos: 1, Balizas: 1, Notificaciones: this.opacidad});
	}
	resaltarBalizasSeleccionadas(){

		// Desmarcamos todas las balizas
		this.desmarcarBalizas();

		// Marcamos las Balizas a Resaltar
		this.balizasResaltar.forEach(element => {
			this.resaltarBaliza(element.getId());
		});
	}
	resaltarBaliza(id){
		this.opacidad = 0.2;
		console.log('Marcamos la Baliza: ' + id);
		const beaconPlano = this.mapBeacons.get(id);
		beaconPlano.symbolStroke =  Constantes.nodoSymbolStroke_SELECT;
		beaconPlano.symbolFill =   Constantes.nodoSymbolFill_SELECT;
		beaconPlano.symbolStrokeWidth =   Constantes.nodoSymbolStrokeWidth_SELECT;
		beaconPlano.sectionHoverFill =   Constantes.nodoSectionHoverFill_SELECT;
		beaconPlano.sectionHoverStroke =   Constantes.nodoSectionHoverStroke_SELECT;
		beaconPlano.symbolHoverFill = Constantes.nodosymbolHoverFill;
		beaconPlano.symbolHoverStroke = Constantes.nodosymbolHoverStroke;
		beaconPlano.symbolSize =   Constantes.nodoSymbolSize_SELECT;
		beaconPlano.setIconHeight(Constantes.nodoIconHeight_SELECT);
		beaconPlano.setIconWidth(Constantes.nodoIconWidth_SELECT);
		this.mapBeacons.set(id, beaconPlano);

		this.setTransparenciaCapa({ secciones: this.opacidad, nodos: 1, conexiones: this.opacidad, contenidos: this.opacidad, Balizas: 1, Notificaciones: this.opacidad});

		const auxArray = [];
		this.mapBeacons.forEach((value: BeaconPlano, key: string) => {
			auxArray.push(value);
		});

		this.asignarBeacons(auxArray);
	}
	resaltarSeccionSeleccionado(id?){
		this.opacidad = 1;
		if (id){
			this.opacidad = 0.2;
			// Desmarcamos todas las seccionPlano
			this.mapSections.forEach((value: SeccionPlano, key: string) => {
				const arrayColor = value.ENTIDAD.Color.split('rgba(')[1].split(')')[0].split(',');
				const objetoColor =  {r: arrayColor[0], g: arrayColor[1], b: arrayColor[2], a: arrayColor[3]};
				const arrayColorHover = Constantes.seccionHoverFill.split('rgba(')[1].split(')')[0].split(',');
				const objetoColorHover  =  {r: arrayColorHover[0], g: arrayColorHover[1], b: arrayColorHover[2], a: arrayColorHover[3]};
				// Creamos el color hover de la seccion con el alfa del color de la seccion en reposo
				const seccionHoverColor = 'rgba(' + objetoColorHover.r + ',' + objetoColorHover.g + ','  + objetoColorHover.b + ',' + objetoColor.a + ')';
				// Relleno Seccion
				value.fill  = value.ENTIDAD.Color;		// Reposo
				value.hoverFill = seccionHoverColor;	// Hover
				// Arista Seccion
				value.stroke = value.ENTIDAD.Color;					// Reposo
				value.hoverStroke = Constantes.seccionHoverStroke;	// Hover
				// Ancho
				value.strokeWidth = Constantes.seccionStrokeWidth;
				this.mapSections.set(key, value);
			});
			// Marcamos la seccionPlano seleccionada
			const seccionPlano = this.mapSections.get(id);
			seccionPlano.stroke = Constantes.seccionStroke_SELECT;
			seccionPlano.fill = Constantes.seccionFill_SELECT;
			seccionPlano.strokeWidth = Constantes.seccionStrokeWidth_SELECT;
			seccionPlano.hoverFill = Constantes.seccionHoverFill;
			seccionPlano.hoverStroke = Constantes.seccionHoverStroke;
			this.mapSections.set(id, seccionPlano);
		}
		else {
			// Desmarcamos todas las conexiones
			this.mapSections.forEach((value: SeccionPlano, key: string) => {
				// Si no tiene color le seteamos uno gris por defecto
				if (value.ENTIDAD.Color === null) {
					value.ENTIDAD.Color = 'rgba(255, 255, 255, 0.5)';
				}
				const arrayColor = value.ENTIDAD.Color.split('rgba(')[1].split(')')[0].split(',');
				const objetoColor =  {r: arrayColor[0], g: arrayColor[1], b: arrayColor[2], a: arrayColor[3]};
				const arrayColorHover = Constantes.seccionHoverFill.split('rgba(')[1].split(')')[0].split(',');
				const objetoColorHover  =  {r: arrayColorHover[0], g: arrayColorHover[1], b: arrayColorHover[2], a: arrayColorHover[3]};
				// Creamos el color hover de la seccion con el alfa del color de la seccion en reposo
				const seccionHoverColor = 'rgba(' + objetoColorHover.r + ',' + objetoColorHover.g + ','  + objetoColorHover.b + ',' + objetoColor.a + ')';
				// Relleno Seccion
				value.fill  = value.ENTIDAD.Color;		// Reposo
				value.hoverFill = seccionHoverColor;	// Hover
				// Arista Seccion
				value.stroke = value.ENTIDAD.Color;					// Reposo
				value.hoverStroke = Constantes.seccionHoverStroke;	// Hover
				// Ancho
				value.strokeWidth = Constantes.seccionStrokeWidth;

				this.mapSections.set(key, value);
			});
		}

		this.setTransparenciaCapa({ secciones: 1, nodos: this.opacidad, conexiones: this.opacidad, contenidos: this.opacidad, Balizas: this.opacidad, Notificaciones: this.opacidad});

	}
	resaltarContenidoSeleccionado(id?){
		this.opacidad = 1;
		if (id){
			this.opacidad = 0.2;
			// Desmarcamos todos los Contenidos
			this.mapContents.forEach((value: ContenidoPlano, key: string) => {
				if (value.ENTIDAD.TIPOLOGIA_CONTENIDO.VisibilidadIconoMapa) {
					value.symbolStroke = Constantes.contenidoSymbolStroke;
					value.symbolFill = Constantes.contenidoSymbolFill;
					value.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
					value.symbolSize = Constantes.contenidoSymbolSize;
					value.symbolHoverFill = Constantes.contenidosymbolHoverFill;
					value.symbolHoverStroke = Constantes.contenidosymbolHoverStroke;
					value.sectionHoverFill = Constantes.contenidoSectionHoverFill;
					value.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
					value.setIconHeight(Constantes.contenidoIconHeight);
					value.setIconWidth(Constantes.contenidoIconWidth);
					this.mapContents.set(key, value);
				}
			});
			// Marcamos el nuevo Contenido seleccionad0
			const contenidoPlano = this.mapContents.get(id);
			if (contenidoPlano.ENTIDAD.TIPOLOGIA_CONTENIDO.VisibilidadIconoMapa) {
				contenidoPlano.symbolStroke = Constantes.contenidoSymbolStroke_SELECT;
				contenidoPlano.symbolFill = Constantes.contenidoSymbolFill_SELECT;
				contenidoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth_SELECT;
				contenidoPlano.symbolSize = Constantes.contenidoSymbolSize_SELECT;
				contenidoPlano.symbolHoverFill = Constantes.contenidosymbolHoverFill;
				contenidoPlano.symbolHoverStroke = Constantes.contenidosymbolHoverStroke;
				contenidoPlano.sectionHoverFill = Constantes.contenidoSectionHoverFill_SELECT;
				contenidoPlano.sectionHoverStroke = Constantes.contenidoSectionHoverStroke_SELECT;
				contenidoPlano.setIconHeight(Constantes.contenidoIconHeight);
				contenidoPlano.setIconWidth(Constantes.contenidoIconWidth);
				this.mapContents.set(id, contenidoPlano);
			}
			else{
			}
		}
		else {
			// Desmarcamos todos los Contenidos
			this.mapContents.forEach((value: ContenidoPlano, key: string) => {
				if (value.ENTIDAD.TIPOLOGIA_CONTENIDO.VisibilidadIconoMapa) {
					value.symbolStroke = Constantes.contenidoSymbolStroke;
					value.symbolFill = Constantes.contenidoSymbolFill;
					value.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
					value.symbolSize = Constantes.contenidoSymbolSize;
					value.symbolHoverFill = Constantes.contenidosymbolHoverFill;
					value.symbolHoverStroke = Constantes.contenidosymbolHoverStroke;
					value.sectionHoverFill = Constantes.contenidoSectionHoverFill;
					value.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
					value.setIconHeight(Constantes.contenidoIconHeight);
					value.setIconWidth(Constantes.contenidoIconWidth);
					this.mapContents.set(key, value);
				}
			});
		}
		this.setTransparenciaCapa({ secciones: this.opacidad, nodos: this.opacidad, conexiones: this.opacidad, contenidos: 1, Balizas: this.opacidad, Notificaciones: this.opacidad});
	}

	/* ** Visibilidad Capas ** */
	menuVisibilidadCommand(comando) {
		console.log(comando)
		if (comando.item.id === 'SECCIONES') {
			this.mostrarSecciones = !this.mostrarSecciones;
			if (!this.mostrarSecciones) {
				comando.item.icon = 'iticon-tab-ocultar iticon-px32';
			}
			else{
				comando.item.icon = 'iticon-tab-mostrar iticon-px32';
			}
			console.log('mostrarSecciones: ' + this.mostrarSecciones);
		}
		else if (comando.item.id === 'NODOS') {
			this.mostrarNodos = !this.mostrarNodos;
			if (!this.mostrarNodos) {
				comando.item.icon = 'iticon-tab-ocultar iticon-px32';
			}
			else{
				comando.item.icon = 'iticon-tab-mostrar iticon-px32';
			}
			console.log('mostrarNodos: ' + this.mostrarNodos);
		}
		else if (comando.item.id === 'TRAMOS') {
			this.mostrarTramos = !this.mostrarTramos;
			if (!this.mostrarTramos) {
				comando.item.icon = 'iticon-tab-ocultar iticon-px32';
			}
			else{
				comando.item.icon = 'iticon-tab-mostrar iticon-px32';
			}
			console.log('mostrarTramos: ' + this.mostrarTramos);
		}
		else if (comando.item.id === 'CONTENIDOS') {
			this.mostrarContenidos = !this.mostrarContenidos;
			if (!this.mostrarContenidos) {
				comando.item.icon = 'iticon-tab-ocultar iticon-px32';
			}
			else{
				comando.item.icon = 'iticon-tab-mostrar iticon-px32';
			}
			console.log('mostrarContenidos: ' + this.mostrarContenidos);
		}
		else if (comando.item.id === 'BALIZAS') {
			this.mostrarBalizas = !this.mostrarBalizas;
			if (!this.mostrarBalizas) {
				comando.item.icon = 'iticon-tab-ocultar iticon-px32';
			}
			else{
				comando.item.icon = 'iticon-tab-mostrar iticon-px32';
			}
			console.log('mostrarBalizas: ' + this.mostrarBalizas);
		}
		else if (comando.item.id === 'NOTIFICACIONES'){
			this.mostrarNotificaciones = !this.mostrarNotificaciones;
			if (!this.mostrarNotificaciones) {
				comando.item.icon = 'iticon-tab-ocultar iticon-px32';
			}
			else{
				comando.item.icon = 'iticon-tab-mostrar iticon-px32';
			}
			console.log('mostrarNotificaciones: ' + this.mostrarNotificaciones);
		}
	}

	/* ** MINIMIZAR FORMULARIOS ** */
	minimizarNodo($event, Formulario){
		console.log(Formulario);
		console.log($event);
		this.formularioNodoMaximizado = !this.formularioNodoMaximizado;
	}
	minimizarSeccion($event, Formulario){
		console.log(Formulario);
		console.log($event);
		this.formularioSeccionMaximizado = !this.formularioSeccionMaximizado;
	}
	minimizarConexion($event, Formulario){
		console.log(Formulario);
		console.log($event);
		this.formularioConexionMaximizado = !this.formularioConexionMaximizado;
	}

	/* Plano Nodo Portal */
	onAlaPortalChange($event){
		console.log('*** Planoha cambiado a ' + $event.Nomobre + ' ***');
		this.alaSeleccionada = $event.ENTIDAD;
		this.cargarPlano();
	}

	/* ***** RECALCULAR ASIGNACION  de Nodos a Secciones Modificadas ***** */
	public reasignarNodo(Nodo: any) {
		let seccionDetectada;
		// const contentPlano = this.mapContents.get(contenido.id);
		console.log(Nodo.X + ' , ' + Nodo.Y);
		//  Calcular la nueva seccion...
		seccionDetectada = this.seccionDefecto;
		this.sections.forEach((seccionPlano: SeccionPlano) => {
			if (seccionPlano.getCoordenadasPoligono()) {
				if (this.pointInPolygon([Nodo.X as number, Nodo.Y as number], seccionPlano.getCoordenadasPoligono())) {
					seccionDetectada = seccionPlano.ENTIDAD;
				}
			}
		});
		Nodo.IdSeccion = seccionDetectada.Id;
		Nodo.NombreSeccion = seccionDetectada.Nombre;
		Nodo.IdSeccion = seccionDetectada.Id;
		return this.entityManagerProvider.saveChanges();
	}

	public reasignarNodosSeccion(seccionFormulario: SeccionFormulario){
		this.contenidosFormulario.forEach(contenido => {
			this.isContenidoEnSeccion(contenido, seccionFormulario);
		});
		const nodosSeccionAntesEditar: NodoFormulario[] = [];
		const nodosQuitadosSeccionTrasEdita: NodoFormulario[] = [];
		const nodosPermanecenSeccionTrasEditar: NodoFormulario[] = [];
		const nodosEnSeccionTrasEditar: NodoFormulario[] = [];
		const nodosNuevosSeccionTrasEditar: NodoFormulario[] = [];
		seccionFormulario.ENTIDAD.NODOS.forEach((value: any) => {
			const nodo = new NodoFormulario().fromENTIDAD(value);
			nodosSeccionAntesEditar.push(nodo);
			const esta = this.isNodoEnSeccion(nodo, seccionFormulario);
			if (!esta) {
				nodosQuitadosSeccionTrasEdita.push(nodo);
			}
			else{
				nodosPermanecenSeccionTrasEditar.push(nodo);
			}
		});
		this.mapNodes.forEach((value: NodoPlano, key: string) => {
			const nodo = new NodoFormulario().fromNodoPlano(value);
			const esta = this.isNodoEnSeccion(nodo, seccionFormulario);
			if (esta) {
				nodosEnSeccionTrasEditar.push(nodo);
			}
		});
		nodosEnSeccionTrasEditar.forEach(nodo => {
			const encontrado = nodosSeccionAntesEditar.find( x => x.ENTIDAD.Id === nodo.ENTIDAD.Id);
			if (!encontrado) {
				nodosNuevosSeccionTrasEditar.push(nodo);
			}
		});
		console.log('NODOS Eliminados');
		nodosQuitadosSeccionTrasEdita.forEach(nodo => {
			console.log('NODO: ' + nodo.Nombre + ' Esta dentro de: ' + seccionFormulario.Nombre);
			// Si se ha sacado un nodo de la seccion lo asignamos a la seccion por defecto
			nodo.ENTIDAD.IdSeccion = this.seccionDefecto.Id;
		});

		console.log('NODOS Añadidos');
		nodosNuevosSeccionTrasEditar.forEach(nodo => {
			console.log('NODO: ' + nodo.Nombre + ' Esta dentro de: ' + seccionFormulario.Nombre);
			// Agregamos los nuevos nodos a la seccion si estaban asignados a la seccion default
			if (nodo.ENTIDAD.IdSeccion = this.seccionDefecto.Id) {
				nodo.ENTIDAD.IdSeccion = this.mapSections.get(seccionFormulario.ENTIDAD.Id).getId();
			}
		});
		this.entityManagerProvider.saveChanges()
		.then(function(msg){
			console.log(msg);
		})
		.catch(function(msg){
			console.log(msg);
		});
	}

	public reasignarContenidosSeccion(seccionFormulario: SeccionFormulario){
		console.log('TODO: reasignarContenidosSeccion()');
		// this.contenidosFormulario.forEach(contenido => {
		// 	this.isContenidoEnSeccion(contenido, seccionFormulario);
		// });
	}

	public isContenidoEnSeccion(contenido: Contenido, seccion: SeccionFormulario): boolean{
		const inside = require('point-in-polygon');
		const polygon = JSON.parse(seccion.ENTIDAD.CoordenadasPoligono);
		const dentro = inside([ contenido.X, contenido.Y ], polygon);
		// if (dentro) { console.log('CONTENIDO: ' + contenido.Titulo + ' Esta dentro de: ' + seccion.Nombre); }
		return dentro;
	}
	public isNodoEnSeccion(nodo: NodoFormulario, seccion: SeccionFormulario): boolean{
		const inside = require('point-in-polygon');
		const polygon = JSON.parse(seccion.ENTIDAD.CoordenadasPoligono);
		const dentro = inside([ nodo.X, nodo.Y ], polygon);
		// if (dentro) { console.log('NODO: ' + nodo.Nombre + ' Esta dentro de: ' + seccion.Nombre); }
		return dentro;
	}
	/* ***** RECALCULAR ASIGNACION DE CONTENIDO ***** */
	public reasignarContenidos() {
		console.log('***** RECALCULAR ASIGNACION DE CONTENIDO ***** ');
		this.contents.forEach(contenido => {
			this.reasignarContenido(contenido);
		});
		this.entityManagerProvider.saveChanges();
	}
	public reasignarContenido(contenido) {
		console.log('');
		console.log('Contenido: ' + contenido.nombre);
		console.log('---------------------------------');
		const click_X = contenido.getX();
		const click_Y = contenido.getY();
		const seccionDetectada = this.detectarSeccion(contenido);
		const nodosSeccionDetectada = seccionDetectada ? seccionDetectada.NODOS : [];
		const nodoMasCercano = this.detectarNodoCercano(contenido, nodosSeccionDetectada);
		if (seccionDetectada && nodoMasCercano) {
			console.log('Seccion Seleccionada:  ' + seccionDetectada.Nombre);
			if (contenido.ENTIDAD.SECCIONES.length > 0) {
				// Cogemos la seccion que fue asignada al posicionar el contenido por medio del nodo
				const nodoAntiguo = contenido.ENTIDAD.NODODS[0].NODO;
				const seccionAntigua = nodoAntiguo.SECCION;
				// Filtrar de las secciones asignadas al contenido la seccionAntigua y cambio la seccion
				const seccion_aux = contenido.ENTIDAD.SECCIONES.filter( s => s.IdSeccion === seccionAntigua.Id)[0];
				if (seccion_aux) {
					seccion_aux.SECCION = seccionDetectada;
				}
				else{
					// Si no existia relacion con la seccion anterior asumimos que la numero 0 es la asignada por posicionamiento
					contenido.ENTIDAD.SECCIONES[0].SECCION = seccionDetectada;
				}
				// contenido.ENTIDAD.SECCIONES[0].SECCION = seccionDetectada;
				console.log('Nodo mas Cercano:  ' + nodoMasCercano.Nombre);
				if (contenido.ENTIDAD.NODODS.length > 0) {
					contenido.ENTIDAD.NODODS[0].NODO = nodoMasCercano;
					contenido.X = click_X;
					contenido.Y = click_Y;
				}
				else{
					console.log('NODO no Asignado -> Contenido: ' + contenido.nombre);
					this.crearRelacionNodo_has_Contenido(contenido, nodoMasCercano)
					.then(function(NODO_has_CONTENIDO){
						contenido.X = click_X;
						contenido.Y = click_Y;
					});
				}
			}
			else{
				console.log('SECCION Seccion_hasContenido -> Contenido: ' + contenido.nombre);
				const that = this;
				this.crearRelacionSeccion_has_Contenido(contenido, seccionDetectada)
				.then(function(SECCION_has_CONTENIDO){
					return that.crearRelacionNodo_has_Contenido(contenido, nodoMasCercano);
				})
				.then(function(NODO_has_CONTENIDO){
					contenido.X = click_X;
					contenido.Y = click_Y;
				});
			}
		}
		else{
			if (!seccionDetectada) {
				console.error('No seccionDetectada -> Contenido: ' + contenido.nombre);
			}
			if (!nodoMasCercano) {
				console.error('No nodoMasCercano -> Contenido: ' + contenido.nombre);
			}
		}
	}
	detectarSeccion(contenido){
		let seccionDetectada;
		const click_X = contenido.getX();
		const click_Y = contenido.getY();
		console.log(contenido.X + ' , ' + contenido.Y);
		//  Calcular la nueva seccion...
		seccionDetectada = this.seccionDefecto;
		this.sections.forEach((seccionPlano: SeccionPlano) => {
			if (seccionPlano.getCoordenadasPoligono()) {
				if (this.pointInPolygon([click_X as number, click_Y as number], seccionPlano.getCoordenadasPoligono())) {
					seccionDetectada = seccionPlano.ENTIDAD;
				}
			}
		});
		return seccionDetectada;
	}
	detectarNodoCercano(contenido, nodosSeccionDetectada){
		let nodoMasCercano;
		let distanciaMinima = Constantes.MAX_PESO;
		// d = sqrt( (x2 - x1)^2 + (y2 - y1)^2 )
		nodosSeccionDetectada.forEach(nodo => {
			const x1 = nodo.X;
			const y1 = nodo.Y;
			const x2 = contenido.getX();
			const y2 = contenido.getY();
			const d = Math.sqrt( Math.pow((x2 - x1), 2) + Math.pow((y2 - y1), 2) );
			console.log('--- Distancia a: ' + nodo.Nombre + ' = ' + d);
			if (d < distanciaMinima) {
				distanciaMinima = d;
				nodoMasCercano = nodo;
			}
		});
		return nodoMasCercano;
	}
	crearRelacionSeccion_has_Contenido(contenido, seccionDetectada){
		const that = this;
		return this.entityManagerProvider.newSECCION_has_CONTENIDO()
		.then(function(SECCION_has_CONTENIDO){
			const element = SECCION_has_CONTENIDO;
			element.CONTENIDO = contenido.ENTIDAD;
			element.IdContenido = contenido.ENTIDAD.Id;
			element.SECCION = seccionDetectada;
			element.IdSeccion = seccionDetectada.Id;
			element.Prioridad = 0;
			element.PrioridadDestacado = 0;
			return element;
		});
	}
	crearRelacionNodo_has_Contenido(contenido, nodoMasCercano){
		const that = this;
		return this.entityManagerProvider.newNODO_has_CONTENIDO()
		.then(function(NODO_has_CONTENIDO){
			const element = NODO_has_CONTENIDO;
			element.CONTENIDO = contenido.ENTIDAD;
			element.IdContenido = contenido.ENTIDAD.Id;
			element.NODO = nodoMasCercano;
			element.IdNodo = nodoMasCercano.Id;
			return element;
		});
	}
	/* Inicializadores Elementos PLano */
	setContenidoPlano(contenido){
		try {
			let contenidoPlano;
			
			if (contenido.TIPOLOGIA_CONTENIDO) {
				if(contenido.ALA_PLANO){
					contenidoPlano = new ContenidoPlano(contenido.IdContenido, contenido.Titulo, contenido.X, contenido.Y, contenido.TIPOLOGIA_CONTENIDO.IconoRepresentacion, [], contenido.ALA_PLANO.IconoContenidoScale);
				}else{
					contenidoPlano = new ContenidoPlano(contenido.IdContenido, contenido.Titulo, contenido.X, contenido.Y, contenido.TIPOLOGIA_CONTENIDO.IconoRepresentacion, [], 1);
				}
				
			}
			else{
				const icono = 'assets/planos/iconos/' + 'wifi.png';
				if(contenido.ALA_PLANO){
					contenidoPlano = new ContenidoPlano(contenido.IdContenido, contenido.Titulo, contenido.X, contenido.Y, icono, [], contenido.ALA_PLANO.IconoContenidoScale);
				}else{
					contenidoPlano = new ContenidoPlano(contenido.IdContenido, contenido.Titulo, contenido.X, contenido.Y, icono, [], 1);
				}
				
				console.log('5.- NO TIPOLOGIA NODO');
			}
			contenidoPlano.ENTIDAD = contenido.ENTIDAD;
			// Ancho maximo Limitado
			// Nº Lineas maximo
			// Elipsis
			// hover
			if (contenido.TIPOLOGIA_CONTENIDO.VisibilidadIconoMapa) {
				contenidoPlano.symbolStroke = Constantes.contenidoSymbolStroke;
				contenidoPlano.symbolFill = Constantes.contenidoSymbolFill;
				contenidoPlano.symbolStrokeWidth = Constantes.contenidoSymbolStrokeWidth;
				contenidoPlano.symbolSize = Constantes.contenidoSymbolSize;
				contenidoPlano.symbolHoverFill = Constantes.contenidosymbolHoverFill;
				contenidoPlano.symbolHoverStroke = Constantes.contenidosymbolHoverStroke;
				contenidoPlano.sectionHoverFill = Constantes.contenidoSectionHoverFill;
				contenidoPlano.sectionHoverStroke = Constantes.contenidoSectionHoverStroke;
				contenidoPlano.setIconHeight(Constantes.contenidoIconHeight);
				contenidoPlano.setIconWidth(Constantes.contenidoIconWidth);
				contenidoPlano.setIconAlign(contenido.TIPOLOGIA_CONTENIDO.AnchorPoint);
				// Posicionamos label
				const alineacion = contenido.TIPOLOGIA_CONTENIDO.AnchorPoint;
				const width =  parseInt(Constantes.contenidoIconWidth, 0);
				if (alineacion === 'top-left') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10 + width);
					contenidoPlano.setLabelYoffset(30);
				}
				else if (alineacion === 'top-center') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10 + (width / 2));
					contenidoPlano.setLabelYoffset(30);
				}
				else if (alineacion === 'top-right') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10);
					contenidoPlano.setLabelYoffset(30);
				}
				else if (alineacion === 'center-left') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10 + width);
					contenidoPlano.setLabelYoffset(-15);
				}
				else if (alineacion === 'center-center') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10 + (width / 2));
					contenidoPlano.setLabelYoffset(-15);
				}
				else if (alineacion === 'center-right') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10);
					contenidoPlano.setLabelYoffset(-15);
				}
				else if (alineacion === 'bottom-left') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10 + width);
					contenidoPlano.setLabelYoffset(-30);
				}
				else if (alineacion === 'bottom-center') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10 + (width / 2));
					contenidoPlano.setLabelYoffset(-30);
				}
				else if (alineacion === 'bottom-right') {
					contenidoPlano.setLabelTextAnchor(Constantes.labelTextLeft);
					contenidoPlano.setLabelXoffset(10);
					contenidoPlano.setLabelYoffset(-30);
				}
			}
			else{
				contenidoPlano.symbolStroke = '';
				contenidoPlano.symbolFill = '';
				contenidoPlano.symbolStrokeWidth = '';
				contenidoPlano.symbolSize = 0;
				contenidoPlano.symbolHoverFill = '';
				contenidoPlano.symbolHoverStroke = '';
				contenidoPlano.sectionHoverFill = '';
				contenidoPlano.sectionHoverStroke = '';
				contenidoPlano.setIconHeight('');
				contenidoPlano.setIconWidth('');
				contenidoPlano.setIconAlign('');
				// Posicionamos label
				contenidoPlano.setLabelTextAnchor(Constantes.labelTextMiddle);
				contenidoPlano.setLabelXoffset(0);
				contenidoPlano.setLabelYoffset(0);
			}
			if (contenido.TIPOLOGIA_CONTENIDO.VisibilidadLabelMapa) {
				contenidoPlano.setLabel(contenido.NombreCorto); // Label desde BD
				contenidoPlano.setLabelColor(Constantes.labelColor);
				contenidoPlano.setLabelFontFamily(Constantes.labelFontFamily);
				contenidoPlano.setLabelFontSize(Constantes.labelFontSize);
			}
			else{
				contenidoPlano.setLabel(''); // Label desde BD
				contenidoPlano.setLabelColor('');
				contenidoPlano.setLabelFontFamily('');
				contenidoPlano.setLabelFontSize('');
			}
			return contenidoPlano;
		}
		catch (ex) {
			this.appComponent.showError(ex);
		}
	}
	comprobarConversionCoordenadas(event: any): any {
		const that = this;
		const idEspacio = this.authService.getIdEspacio();
		const token = this.authService.getToken();
		const idAla = this.alaSeleccionada.Id;
		let X = event.mp[0];
		let Y = event.mp[1];
		let Latitud = 0;
		let Longitud = 0;
		this.sws.wsObtenerLLFromXY(token, X, Y, idEspacio, idAla).toPromise()
		.then(function(resp){
			Latitud = resp.Latitud;
			Longitud = resp.Longitud;
			return that.sws.wsObtenerXYFromLL(token, Latitud, Longitud, idEspacio, idAla).toPromise();
		})
		.then(function(resp){
			X = resp.x;
			Y = resp.y;
			console.log('--- Coordenadas LL: ' + Latitud + ',' + Longitud);
			console.log('--- Coordenadas XY: ' + X + ',' + Y);
		})
		;
	}
	RotarDerecha(rot){
		this.nodes.forEach(element => {
			const rotacion = element.getRotation();
			element.setRotation(rotacion + rot);
		});
		this.asignarNodes(this.nodes);
	}
	RotarIzquierda(rot){
		this.nodes.forEach(element => {
			const rotacion = element.getRotation();
			element.setRotation(rotacion - rot);
		});
		this.asignarNodes(this.nodes);
	}

	inputFechaChanged(){
		this.asignarSections();
		this.asignarContents();
		this.asignarBeacons();
		this.asignarLinks(this.links);
		this.asignarNodes(this.nodes);
		this.asignarNotificaciones();
	}

	// ASIGNARCIONES INPUTS PLANO
	asignarSections(arraySeccionesPlano?: Array<SeccionPlano>){
		let secciones = new Array<SeccionPlano>();
		if (!arraySeccionesPlano){
			this.mapSections.forEach((value: SeccionPlano, key: String) => {
				//console.log(key, value);
				const seccionPlano: SeccionPlano = value;
				if (seccionPlano.ENTIDAD.FechaBaja === null || seccionPlano.ENTIDAD.FechaBaja > this.fechaVisualizacion ){
					if (seccionPlano.ENTIDAD.FechaAlta !== null && seccionPlano.ENTIDAD.FechaAlta <= this.fechaVisualizacion ){
						secciones.push(seccionPlano);
					}
				}
			});
		}
		else{
			secciones = arraySeccionesPlano;
		}

		this.sections = secciones;
		this.sections = Object.assign([], this.sections);
	}

	asignarContents(arrayContenidosPlano?: Array<ContenidoPlano>){
		let contenidos =  new Array<ContenidoPlano>();
		if (!arrayContenidosPlano){
			this.contenidosFormulario = [];

			this.mapContents.forEach((value: ContenidoPlano, key: String) => {
				// console.log(key, value);
				const contenido: ContenidoPlano = value;
				if (!contenido) {
					console.log("**** id sin contenido: ", key);
				}
				if (contenido && contenido.ENTIDAD && (contenido.ENTIDAD.FechaBaja === null || contenido.ENTIDAD.FechaBaja > this.fechaVisualizacion) ){
					if (contenido.ENTIDAD.FechaAlta !== null && contenido.ENTIDAD.FechaAlta <= this.fechaVisualizacion ){
						contenidos.push(contenido);
						const contenidoForm = new Contenido().fromENTIDAD(contenido.ENTIDAD);
						this.contenidosFormulario.push(contenidoForm);
					}
				}
			});
		}
		else{
			contenidos = arrayContenidosPlano;
		}
		this.contents = contenidos;
		this.contents = Object.assign([], this.contents);
	}


	asignarBeacons(arrayBalizasPlano?: Array<BeaconPlano>){
		let balizas = new Array<BeaconPlano>();
		if (!arrayBalizasPlano){
			this.mapBeacons.forEach((value: BeaconPlano, key: String) => {
				//console.log(key, value);
				const baliza: BeaconPlano = value;
				if (baliza.ENTIDAD.FechaBaja === null || baliza.ENTIDAD.FechaBaja > this.fechaVisualizacion ){
					if (baliza.ENTIDAD.FechaAlta !== null && baliza.ENTIDAD.FechaAlta <= this.fechaVisualizacion ){
						balizas.push(baliza);
					}
				}
			});
		}
		else{
			balizas = arrayBalizasPlano;
		}

		this.beacons = balizas;
		this.beacons = Object.assign([], this.beacons);
	}

	asignarLinks(conexiones){

		this.links = conexiones;
		this.links = Object.assign([], this.links);
	}

	asignarNodes(nodos){
		this.nodes = nodos;
		this.nodes = Object.assign([], this.nodes);
	}

	asignarNotificaciones(arrayNotificacionesPlano?){
		let notificaciones = new Array<NotificacionPlano>();
		if (!arrayNotificacionesPlano){
			this.mapNotifications.forEach((value: NotificacionPlano, key: String) => {
				console.log(key, value);
				const notificacion: NotificacionPlano = value;
				if (notificacion.ENTIDAD.FechaFin === null || notificacion.ENTIDAD.FechaFin > this.fechaVisualizacion ){
					if (notificacion.ENTIDAD.FechaInicio !== null && notificacion.ENTIDAD.FechaInicio <= this.fechaVisualizacion ){
						notificaciones.push(notificacion);
					}
				}
			});
		}
		else{
			notificaciones = arrayNotificacionesPlano;
		}

		this.notifications = notificaciones;
		this.notifications = Object.assign([], this.notifications);
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'fechaVisualizacion') {
			this.fechaVisualizacion = fecha;
		}

		this.inputFechaChanged();
		calendar.overlayVisible=false;

	}

	/*
	asignarAvisos(avisos){
		this.notifications = avisos;
		this.notifications = Object.assign([], this.notifications);
	}

	obtenerAlasPortal(that?){

		that = this !== undefined ? this : that;
		const entityManager = that.entityManagerProvider;

		let includes = 'SECCIONS.IDIOMAS, SECCIONS.NODOS.IDIOMAS, SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN.IDIOMAS, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO.IDIOMAS';
		includes = includes + ', SECCIONS.NODOS.CONEXIONS_NODOS_ORIGEN.PESO_CONEXIONS, SECCIONS.NODOS.CONEXIONS_NODOS_DESTINO.PESO_CONEXIONS';

		return entityManager.getALA(undefined, includes)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY ALAS');
			}
			else {
				that.alasPortal = [];
				let i = 0;
				entidades.forEach(ala => {
					const aux = new AlaFormulario(ala);
					// Añadimos todas las alas que no sean la seleccionada ya que esta ya esta en el array
					if (ala.Id !== that.alaSeleccionada.id ){
						that.alasPortal.push(aux);
					}
					i += 1;
				});
				console.log('ALA CARGADA CORRECTAMENTE = ' + that.alaSeleccionada.Nomobre);
			}
		})
		.catch(function(err){
			throw err;
		});
	}
	*/

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/mapas/mapas.component.ts